import axios from 'axios';
import { mobileGestureHandle } from '../common/hammer';
import { paintPathGradient1, paintPathGradient2, PathPainter } from '../common/path';
// import { SolveSocket } from './socket'
// import { Socket } from 'socket.io-client';
import { pcGestureHandle } from '../common/pcHammer';
import { Char, Common, Line, LoadState, Phrase, RemoteImageData } from '../types/commontypes';
import { AnimInfo, PgConst, Slide, ViewMode } from '../types/pgtypes';
import { ImageObj, ObjType, Page, PathObj, TAttr, TextObj, Watermark, WpConst, WpDocument } from '../types/wptypes';
import { Animation } from "./animation";
import { AnimationContext, AnimationManager } from './animmanager';
import { Caret } from './click';
import { PrintService } from './print';
import { SearchService } from './search';
import { Thumbnail } from './thumbnail';
import { Util } from './util';
declare global { var $: any }

export class PgReader {

  public static instance: PgReader;


  private thumbnail: Thumbnail = new Thumbnail() // ppt的缩略图
  private viewMode: ViewMode = ViewMode.SinglePage

  public canvas: HTMLCanvasElement
  g: CanvasRenderingContext2D
  mask: HTMLCanvasElement
  signPad: HTMLCanvasElement
  private maskg: CanvasRenderingContext2D
  canvasWidth = 100
  canvasHeight = 100
  doc: WpDocument
  readerWrapper: HTMLDivElement
  canvasWrapper: HTMLDivElement
  leftBtn: HTMLDivElement
  rightBtn: HTMLDivElement
  blackCover: HTMLDivElement
  pageUrlRoot: string // the parent path of index.json
  private container: HTMLDivElement
  private scroller: HTMLDivElement
  private scrollerContent: HTMLDivElement
  public zoom: number = 1
  private viewHeight: number
  startPageIndex: number = 0
  private endPageIndex: number = 0
  private scrolly: number = 0
  private disableScrollEvent: boolean
  private loadingImages: { [path: string]: RemoteImageData } = Object.create(null)

  private upDownGap: number = 20 // 控制上下距离边的距离
  private leftRightGap: number = 1 // 控制左右距离边的距离

  //选取的变量
  public caret1: Caret = Object.create(null)
  public caret2: Caret = Object.create(null)
  private isMouseDown: boolean
  private selectColor: string = '#357EC7'
  // 防复制的变量
  private isCopy: boolean
  // 防选取的变量
  private isPaintSelect: boolean
  // 是否显示备注
  private showComment: boolean = false
  // 是否开启同步
  // private isSocket: boolean
  private suffixUrl: string
  private dyWaterMark: Watermark = Object.create(null)

  private isIp: boolean

  // 全屏签批的变量
  private isSign: boolean
  private signaturePad: any
  private showSign: boolean
  // 背景颜色的设置，在实例化的时候
  private backgroundColor: string
  // 设置页面高度大小，实例化的时候传进宽度和高度
  private parentWidth: number
  private parentHeight: number

  // 判断是否是演讲者或者是听众 1代表教师或者演讲者 2代表学生或者听众
  public role: number
  // 是否点击了超链接
  private isInternalHyperlinkClicked: boolean

  constructor(obj: any) {
    let container: HTMLDivElement = obj.container
    let backgroundColor: string = obj.backgroundColor
    let parentWidth: number = obj.parentWidth
    let parentHeight: number = obj.parentHeight
    PgReader.instance = this
    PgReader.instance['animationManager'] = AnimationManager.instance
    this.backgroundColor = backgroundColor;
    this.parentWidth = parentWidth;
    this.parentHeight = parentHeight;
    this.scroller = document.getElementById('scroller') as HTMLDivElement
    this.scrollerContent = document.getElementById('scrollercontent') as HTMLDivElement
    this.isIp = false
    this.isSign = false
    this.showSign = false
    this.container = container;
    let readerWrapper = this.readerWrapper = document.createElement('div')
    readerWrapper.id = 'dcs-pgreader-wrapper'
    readerWrapper.style.background = backgroundColor


    let canvas = this.canvas = this.createCanvas(this.canvasWidth, this.canvasHeight)
    canvas.style.background = backgroundColor
    this.g = canvas.getContext('2d')
    let canvasWrapper = this.canvasWrapper = document.createElement('div')
    canvasWrapper.id = 'dcs-pgreader-canvaswrapper'
    canvasWrapper.style.margin = '0 auto'
    canvasWrapper.style.overflow = 'auto hidden'
    canvasWrapper.style.position = 'relative'
    canvasWrapper.appendChild(canvas)

    let mask = this.mask = this.createCanvas(this.canvasWidth, this.canvasHeight)
    this.maskg = mask.getContext('2d')
    mask.style.position = 'absolute'
    mask.style.pointerEvents = 'none'
    mask.style.left = '0px'
    mask.style.top = '0px'
    canvasWrapper.appendChild(mask)

    let signPad = this.signPad = this.createCanvas(this.canvasWidth, this.canvasHeight)
    signPad.style.position = 'absolute'
    signPad.style.pointerEvents = 'none'
    signPad.style.left = '0px'
    signPad.style.top = '0px'
    signPad.style.zIndex = '2'
    canvasWrapper.appendChild(signPad)

    readerWrapper.appendChild(canvasWrapper)
    container.appendChild(readerWrapper)

    // 判断是否是移动端
    this.isPhone()
    if (!this.isMobile) {
      window.addEventListener('resize', () => {
        // 因为在js设置父容器的宽高，这个resize需要监听，所以在后面执行，加了延时
        setTimeout(() => {
          // // 监听窗口退出全屏解决无法监听Esc按键
          // if (!this.checkFull()) {
          //     this.fullscreenState = false
          // }
          this.resizeWindow(this.currentZoom)
        }, 1);
      }) // 改变屏幕大小，重新调整scroller位置
      readerWrapper.onwheel = (e) => this.onCanvasMouseWheel(e);
      document.getElementById('pg-leftpanel').onwheel = (e) => this.onCanvasMouseWheel(e);
      (readerWrapper as any).onmousewheel = (e) => this.onCanvasMouseWheel(e)
      if (this.JudgmentBrowser()) { // IE11以下onmousedown等点击无效处理
        //IE11 below                                              
        mask.onmousedown = (e) => this.onMouseDown(e)
        mask.onmousemove = (e) => this.onMouseMove(e)
        mask.onmouseup = (e) => this.onMouseUp(e)
      } else {
        //other browser
        canvas.onmousedown = (e) => this.onMouseDown(e)
        canvas.onmousemove = (e) => this.onMouseMove(e)
        canvas.onmouseup = (e) => this.onMouseUp(e)
        canvas.oncontextmenu = (e) => this.onContextMenu(e)
      }
      let leftBtn = this.leftBtn = document.createElement('div')
      leftBtn.id = 'leftBtn'
      leftBtn.className = 'hiden'
      readerWrapper.appendChild(leftBtn)
      let rightBtn = this.rightBtn = document.createElement('div')
      rightBtn.id = 'rightBtn'
      readerWrapper.appendChild(rightBtn)
      // 动画播放完毕，需要一个黑屏
      let blackCover = this.blackCover = document.createElement('div')
      blackCover.id = 'blackCover'
      blackCover.className = 'hiden'
      blackCover.innerText = '放映结束，单击鼠标退出。'
      readerWrapper.appendChild(blackCover)

      // 左右按钮跳页
      this.leftBtn.onclick = () => this.changePageLast()
      this.rightBtn.onclick = () => this.changePageNext()

      // 设置pg-leftpanel的背景颜色,bug号DCS-6501,产品取消背景色
      // $('#pg-leftpanel').css('backgroundColor', backgroundColor)

    }
    if (this.isMobile) {
      this.viewMode = ViewMode.Contious; // 改成连续模式
      // 移动端触摸
      mobileGestureHandle(this, document.getElementById('dcs-pgreader-canvaswrapper'), 'ppt');
    } else {
      pcGestureHandle(this, document.getElementById('dcs-pgreader-canvaswrapper'), 'ppt');
    }

    // 选取复制
    $(document).unbind('keydown').bind('keydown', (e) => {
      if (e.ctrlKey && e.keyCode == 67) {
        if (this.isCopy) {
          e.preventDefault()
          this.onCopy()
        }
      }
      if (e.keyCode == 122) {
        e.preventDefault()
        if (!this.fullscreenState) {
          this.setFullScreen(this.autoAimatePlay)
        }
      }
      // 键盘的上下左右键，还有空格键控制页面切换
      if (e.keyCode == 39 || e.keyCode == 40 || e.keyCode == 32) { // 当为下，右， 空格键时，跳转为下一页
        if (this.fullscreenState) {
          AnimationManager.instance.next()
        } else {
          this.changePageNext()
        }
      } else if (e.keyCode == 37 || e.keyCode == 38) { // 当为上，左， 空格键时，跳转为上一页
        if (this.fullscreenState) {
          AnimationManager.instance.pre()
        } else {
          this.changePageLast()
        }
      }
      //禁用普通电脑ctrl + (+/-),还有mac 的command + (+/-)
      if ((e.ctrlKey === true || e.metaKey === true) && (e.which === 189 || e.which === 173 || e.which === 109)) {
        e.preventDefault();
        this.changeTab(0)
      } else if ((e.ctrlKey === true || e.metaKey === true) && (e.which === 187 || e.which === 61 || e.which === 107)) {
        e.preventDefault();
        this.changeTab(1)
      }
    })



    // 人教数字的不需要监听全屏事件，只需要视频正常播放就行
    // document.addEventListener('fullscreenchange', (e) => {
    //     this.fullStateListener()
    // })
    // document.addEventListener('webkitfullscreenchange', (e) => {
    //     this.fullStateListener()
    // });
    // (document as any).onmsfullscreenchange = (e) => {
    //     this.fullStateListener()
    // }

    let scroller = this.scroller
    scroller.onscroll = () => {
      if (this.disableScrollEvent) {
        requestAnimationFrame(() => this.disableScrollEvent = false)
        return
      }
      var percent = scroller.scrollTop / (scroller.scrollHeight);
      this.onVScrollerScolled(percent)
    }

    window.onbeforeprint = (e) => {
      PrintService.instance.beforePrint(this)
    }
    window.onafterprint = (e) => {
      PrintService.instance.afterPrint(this)
    }

    //search support
    let search = document.getElementById('search') as HTMLInputElement
    if (search) {
      search.onkeydown = (e: KeyboardEvent) => {
        if (!search.value || !this.isPaintSelect) return
        if (e.keyCode == 13) {//enter
          SearchService.instance.search(this, search.value)
        }
      }
    }

    //zoom
    this.scale_text = document.getElementById('scale_text')
    this.currentZoom = Math.round(Number(this.scale_text.innerText.replace(/\%$/, '')) / 100)
    let shrinkBtn = document.getElementById('shrinkBtn')
    shrinkBtn.onclick = () => this.changeTab(0)
    let magnifyBtn = document.getElementById('magnifyBtn')
    magnifyBtn.onclick = () => this.changeTab(1)

    document.addEventListener('mousewheel', function (e: any) {
      e.preventDefault()
    }, { passive: false })

    document.addEventListener('DOMMouseScroll', function (e: any) {
      e.preventDefault()
    }, { passive: false })

    // ppt动画
    $('#dcs-pgreader-wrapper').unbind('click').bind('click', (e) => {
      if (this.fullscreenState && !this.isSign) {
        this.setAnimation()
        if (this.signaturePad) this.signaturePad.clear()
        $('#signMenu').remove()
      }
    })
    // 节流阀操作鼠标移动唤醒工具栏
    $('#dcs-pgreader-wrapper').bind('mousemove', Util.throttle((e) => {
      if (this.fullscreenState && this.showSign) {

        this.showMenu()
      }
    }, 1500, null))
  }

  public toggleSide() {
    requestAnimationFrame(() => this.isHideSidebar())
  }

  private createCanvas(width: number, height: number): HTMLCanvasElement {
    let canvas = document.createElement('canvas')
    canvas.width = width * 2
    canvas.height = height * 2
    canvas.getContext('2d').setTransform(2, 0, 0, 2, 0, 0)
    canvas.style.width = width + 'px'
    canvas.style.height = height + 'px'
    return canvas
  }

  private isElementHidden(e: HTMLElement) {
    return e.style.width == '0px' || e.style.display == 'none'
  }

  private showWidth: number
  private isHideScroller: boolean = false // 当页面缩小的时候，可能会导致不需要滚动条的情况
  public resizeWindow(currentZoom?: number) {
    let toolbarHeight = document.getElementById('botton').clientHeight + 1  //+1是因为需要加上border-bottom的值      
    let leftpanel = document.getElementById('pg-leftpanel')
    let wh = this.checkFull() ? window.innerHeight : this.parentHeight
    let canvasHeight = this.canvasHeight = this.checkFull() || (!this.doc.param.showHeaderBar || this.isMobile) ? wh - 2 : wh - toolbarHeight - 2  // 设置canvasHeight的高度
    if (canvasHeight < 100) canvasHeight = 100

    // 存在ppt只有一页的情况，这种情况会出现不需要滚动条，只存在连续模式中
    if (this.doc.docHeight * this.zoom * currentZoom < canvasHeight && this.viewMode === ViewMode.Contious) {
      this.isHideScroller = true
      $('#changePageNext').addClass('lightgrey unclick')
    } else {
      this.isHideScroller = false
    }
    // let ww = this.viewMode == ViewMode.SinglePage ? document.body.clientWidth - 1 : this.isHideScroller ? document.body.clientWidth - 1 : document.body.clientWidth - WpConst.VScrollerWidth
    // 用 window.innerWidth 而不用document.body.clientWidth 是为了解决搜狗浏览器问题
    let parentWidth = this.checkFull() ? window.innerWidth : this.parentWidth
    let ww = this.viewMode == ViewMode.SinglePage ? parentWidth - 1 : this.isHideScroller ? parentWidth - 1 : parentWidth - WpConst.VScrollerWidth
    if (!this.isMobile) {
      if (!this.isElementHidden(leftpanel)) {
        ww -= leftpanel.offsetWidth + 1
      }
    }
    this.showWidth = ww
    let readerWrapper = this.readerWrapper
    if (this.isMobile) { // 移动端直接是显示整个屏幕即可
      readerWrapper.style.width = document.body.clientWidth + 'px'
    } else if (!!(window as any).ActiveXObject || "ActiveXObject" in window) {// IE浏览器这样设置宽度才能显示滚动条
      readerWrapper.style.width = ww - 2 + 'px'
    } else {
      readerWrapper.style.width = ww - 1 + 'px'
    }

    if (!this.isMobile) document.getElementById('pg-leftpanel').style.height = canvasHeight + 'px'
    let leftRightGap = this.checkFull() ? 1 : this.leftRightGap; // 当全屏的时候，不需要左右间距了
    ww = ww * leftRightGap // let canvas a bit smaller
    if (ww < 100) ww = 100
    if (this.isMobile) ww = document.body.clientWidth // 如果是移动端的话，直接全屏好了
    this.zoom = ww / this.doc.maxPageWidth
    let upDownGap = this.checkFull() ? 0 : this.upDownGap // 当全屏的时候，不需要上下间距了
    // 当存在备注的时候
    if (this.checkFull()) {
      if (!this.isMobile && this.doc.pagesize.height * this.zoom > canvasHeight) {// 当每一页的高度大于当前绘制的区域的高度时，就会上下显示不完全
        this.zoom = canvasHeight / this.doc.pagesize.height
        ww = this.doc.maxPageWidth * this.zoom
      }
    } else {
      if (this.showComment) {
        if (!this.isMobile && this.doc.pagesize.height * this.zoom > canvasHeight * 0.9 - upDownGap) {// 当每一页的高度大于当前绘制的区域的高度时，就会上下显示不完全
          this.zoom = (canvasHeight * 0.9 - upDownGap) / this.doc.pagesize.height
          ww = this.doc.maxPageWidth * this.zoom
        }
      } else {
        if (!this.isMobile && this.doc.pagesize.height * this.zoom > canvasHeight - upDownGap) {// 当每一页的高度大于当前绘制的区域的高度时，就会上下显示不完全
          this.zoom = (canvasHeight - upDownGap) / this.doc.pagesize.height
          ww = this.doc.maxPageWidth * this.zoom
        }
      }
    }

    // 存在ppt只有一页的情况，移动端需要在确定this.zoom情况下才能判断
    if (this.doc.docHeight * this.zoom * currentZoom < canvasHeight && this.isMobile) {
      this.isHideScroller = true
    } else {
      this.isHideScroller = false
    }
    let scroller = this.scroller, scrollerContent = this.scrollerContent
    scroller.style.display = this.viewMode == ViewMode.SinglePage ? 'none' : 'inline-block' // 单页模式不需要滚动条
    scroller.style.height = canvasHeight + 'px'
    //取未zoom变化前的percent，放大缩小基于这个滚动条的百分比进行缩放
    var percent = scroller.scrollTop / (scroller.scrollHeight);
    //更改scroller内容的高度
    scrollerContent.style.height = this.isMobile ? this.doc.docHeight * this.zoom * this.currentZoom + 20 + 'px' : this.doc.docHeight * this.zoom * this.currentZoom + 'px'
    if (percent < 0 || percent > 1 || !this.doc) {
      console.log('update this.scrolly failed!')
    } else {
      this.scrolly = scroller.scrollHeight * percent; //缩放过后的滚动条的计算偏移量
      scroller.scrollTop = this.scrolly               //缩放过后的滚动条的实际偏移量，因为放大缩小会触发滚动事件，所以scrollTop要是实际值保持和计算偏移量一致
    }
    // 如果宽度大于给定的宽度（这种情况只会出现在连续模式中），dcs-pgreader-canvaswrapper不变，只是里面canvas进行变动，如果比例小于1的话，这个跟着canvas一起缩小，是为了方便居中
    if (!this.isMobile) {
      if (this.doc.pagesize.width * this.zoom * currentZoom > this.showWidth) {
        this.canvasWrapper.style.width = this.showWidth + 'px'
        canvasHeight = canvasHeight - 17
      } else {
        this.canvasWrapper.style.width = ww * this.currentZoom + 'px'
        this.leftBtn.style.width = this.showWidth * (1 - leftRightGap) / 2 + 'px'
        this.rightBtn.style.width = this.showWidth * (1 - leftRightGap) / 2 + 'px'
      }
      $('.page').css("left", (leftpanel.clientWidth + readerWrapper.clientWidth / 2) + "px")
      // 调整备注的高度
      if (this.showComment) {
        if ($('#comment').length > 0) {
          $('#comment').css({
            "height": canvasHeight * 0.1 + 'px'
          })
        }
      }
    }
    requestAnimationFrame(() => {
      if (currentZoom) {
        this.canvasWidth = ww * currentZoom
        this.canvasHeight = canvasHeight
        this.resizeCanvas(ww * currentZoom, canvasHeight)
      } else {
        this.canvasWidth = ww
        this.canvasHeight = canvasHeight
        this.resizeCanvas(ww, canvasHeight)
      }
      this.determineVisiblePages()
      this.paint()
    })
  }

  private onVScrollerScolled(percent) {
    if (this.isHideScroller) return // 没有滚动条的时候不需要移动
    if (percent < 0 || percent > 1 || !this.doc) return
    if (this.viewMode == ViewMode.SinglePage) {
      //TODO
    } else {
      this.scrolly = this.doc.docHeight * this.zoom * percent * this.currentZoom;
      this.determineVisiblePages()
      this.changeInputPage(this.startPageIndex) // 实时更新当前page在input框里面的值
      this.deleteMenu()
      requestAnimationFrame(() => this.paint())
      if (this.hasSelection()) {
        this.paintSelection(this.selectColor)
      } else {
        this.paintCaret()
      }
    }
  }

  private onCanvasMouseWheel(e: any) {
    if (this.isHideScroller) return // 没有滚动条的时候不需要移动
    if (this.isSign) return
    let scrolly = this.scrolly, viewHeight = this.viewHeight, docHeight = this.doc.docHeight * this.zoom * this.currentZoom, deltaY = e.deltaY || -(e as any).wheelDelta
    this.deleteMenu()
    if (this.viewMode == ViewMode.Contious) {
      // 因为火狐浏览器滚动的deltaY值较小，所以滚动值参照谷歌浏览器,同时也要兼顾到触摸屏
      if (navigator.userAgent.toLowerCase().match(/firefox/i)) {
        if (deltaY % 3 === 0) {
          if (deltaY < 0) {
            deltaY = -100
          } else if (deltaY > 0) {
            deltaY = 100
          }
        }
      }
      scrolly += deltaY * this.zoom * this.currentZoom;
      if (scrolly < 0) scrolly = 0
      if (scrolly + viewHeight > docHeight) {
        scrolly = docHeight - viewHeight
      }
      if (scrolly !== this.scrolly) {
        this.determineVisiblePages()
        this.changeInputPage(this.startPageIndex) // 实时更新当前page在input框里面的值
        this.gotoPageByScrolly(scrolly)
      }
    } else {
      let old = Math.floor(this.startPageIndex), current
      // 如果是动画状态下，上下滚轮事件就是动画的切换
      if (this.fullscreenState) {
        if (deltaY > 0) {
          AnimationManager.instance.next()
        } else {
          AnimationManager.instance.pre()
        }
      } else {
        if (deltaY > 0) {
          current = Math.min(this.doc.pageCount - 1, old + 1)
        } else {
          current = Math.max(0, old - 1)
        }
        if (old != current) {
          this.gotoPage(current)
        }
      }

    }
  }


  private resizeCanvas(width: number, height: number) {
    this.viewHeight = height
    this.canvasWidth = width
    this.canvasHeight = height

    let canvas = this.canvas, mask = this.mask, sign = this.signPad
    canvas.width = width * 2
    canvas.height = this.canvasHeight * 2
    this.g.setTransform(2 * this.currentZoom, 0, 0, 2 * this.currentZoom, 0, 0)
    canvas.style.width = width + 'px'
    canvas.style.height = this.canvasHeight + 'px'
    mask.width = canvas.width
    mask.height = canvas.height
    this.maskg.setTransform(2 * this.currentZoom, 0, 0, 2 * this.currentZoom, 0, 0)
    mask.style.width = canvas.style.width
    mask.style.height = canvas.style.height
    sign.width = width
    sign.height = height
    sign.style.width = width + 'px'
    sign.style.height = height + 'px'
  }

  gotoPage(index: number, oneSameTimeAimations?: AnimationContext[]) {
    this.changeInputPage(index)
    if (index < 0 || index > this.doc.pages.length - 1) return;
    // 首先删除页面存在的音频和视频
    $('video, audio').remove();
    $('.canvasGif').remove()
    $('.canvasHyperImage').remove();
    this.mediaPath = [];
    // 更新输入框中的跳转页数，更新sidebar中选中框的颜色
    if (this.viewMode == ViewMode.SinglePage) {
      this.startPageIndex = this.endPageIndex = index
      this.disableScrollEvent = true
      requestAnimationFrame(() => {
        if (oneSameTimeAimations) this.paint(false, oneSameTimeAimations)
        else this.paint()
        // 单页不需要有选取框停留
        let maskg = this.maskg
        maskg.clearRect(0, 0, this.canvasWidth / this.currentZoom, this.canvasHeight / this.currentZoom)
      })
    } else {
      let scrolly = this.doc.pages[index].y * this.zoom * this.currentZoom
      let docHeight = this.doc.docHeight * this.zoom * this.currentZoom
      let viewHeight = this.viewHeight
      if (scrolly + viewHeight >= docHeight) scrolly = docHeight - viewHeight
      this.gotoPageByScrolly(scrolly)
    }
    // 每次页码跳转的时候，向ios发送请求,返回当前页码
    // console.log(index + 1);
    // (window as any).webkit.messageHandlers.JKEVentHandaler.postMessage({
    //   messageType: 8,
    //   shareUrl: index + 1
    // });
    try {
      if (this.isMobile) {
        (window as any).webkit.messageHandlers.JKEventHandler.postMessage(JSON.stringify({
          messageType: 8,
          currPage: index + 1
        }));
      }
    } catch (error) {
      console.log(error)
    }
    // 更新左侧缩略图的滚动条的位置 目前滚动条不需要做处理
    // 如果是移动端，则直接返回
    if (this.isMobile) return
    let ele = $(".totalPagePoint")
    let leftPanel = $('#pg-leftpanel')
    // 边距为10，边框粗细为1，加入修正系数12
    // 向下滚动
    if (ele.offset().top + ele.height() - 20 > leftPanel.height()) {
      let scrollTop = (ele.height() + 12) * (index + 1) - leftPanel.height()
      leftPanel.animate({
        scrollTop: scrollTop
      }, 0)
    }
    // 向上滚动
    if (ele.offset().top < 0) {
      let scrollTop = (ele.height() + 12) * (index)
      leftPanel.animate({
        scrollTop: scrollTop
      }, 0)
    }
  }
  private gotoPageByScrolly(scrolly) {
    this.scrolly = scrolly
    this.determineVisiblePages()
    this.disableScrollEvent = true
    this.scroller.scrollTop = scrolly
    requestAnimationFrame(() => {
      this.paint()
      if (this.hasSelection()) {
        this.paintSelection(this.selectColor)
      } else {
        this.paintCaret()
      }
    })
  }


  async open(preUrl: string, suffUrl: string, watermarkParam?: object, role?: number) {
    if (watermarkParam) {
      if (watermarkParam['watermark_txt']) {
        this.dyWaterMark.text = watermarkParam['watermark_txt']
      }
      if (watermarkParam['watermark_x_extra']) {
        this.dyWaterMark.textIndent_x = Number(watermarkParam['watermark_x_extra'])
      }
      if (watermarkParam['watermark_y_extra']) {
        this.dyWaterMark.textIndent_y = Number(watermarkParam['watermark_y_extra'])
      }
      if (watermarkParam['watermark_fontsize']) {
        this.dyWaterMark.fontSize = Number(watermarkParam['watermark_fontsize'])
      }
      if (watermarkParam['watermark_alpha']) {
        this.dyWaterMark.alpha = Number(watermarkParam['watermark_alpha'])
      }
      if (watermarkParam['watermark_angle']) {
        this.dyWaterMark.angle = Number(watermarkParam['watermark_angle'])
      }
      if (watermarkParam['watermark_font']) {
        this.dyWaterMark.family = watermarkParam['watermark_font']
      }
      if (watermarkParam['watermark_color']) {
        this.dyWaterMark.color = watermarkParam['watermark_color']
      }
      this.dyWaterMark.isTile = 1
    }
    this.suffixUrl = suffUrl ? suffUrl : '?'
    this.pageUrlRoot = preUrl.substring(0, preUrl.lastIndexOf('/') + 1)
    let resp = await axios.get(preUrl + this.suffixUrl)
    let doc = this.doc = resp.data as WpDocument
    this.loadedPageCount = doc.pageCount
    // 如果没有设置，暂时默认权限都是演讲者
    this.role = role ? Number(role) : 1;
    requestAnimationFrame(() => dispatchEvent(new CustomEvent('paramData', { detail: { value: doc.param, title: doc.title, ref: doc.ref } })))
    console.log(doc)
    // 增加跳转上下页功能，更新pagecount的数量,更新sidebar的选定框
    this.calcModelSize(doc, null)
    if (!this.doc.complete) {
      requestAnimationFrame(() => this.loadMorePages(preUrl + this.suffixUrl))
    }
    // canvas预览-ppt，网页模式下，若用户窗口过小，自适应隐藏左侧ppt目录，具体效果同高清预览。
    if (!this.isMobile) {
      if (window.innerWidth < 992) {
        if (this.isHide) {
          setTimeout(() => {
            this.isHideSidebar()
          }, 10);
        }
      } else {
        if (this.isHide) {
          setTimeout(() => {
            this.isHideSidebar()
          }, 10);
        }
      }
    }

  }

  private loadedPageCount: number = 0
  private async loadMorePages(url) {
    let resp = await axios.get(url)
    let newData = resp.data as WpDocument
    if (newData.pageCount > this.loadedPageCount || ((newData.pageCount = this.loadedPageCount) && this.doc.complete)) {
      this.calcModelSize(this.doc, newData)
      this.loadedPageCount = newData.pageCount
    }

    if (!this.doc.complete) {
      setTimeout(() => {
        requestAnimationFrame(() => this.loadMorePages(url))
      }, 1000);

    }
    if (this.loadedPageCount == newData.pageCount && newData.complete == 1) {
      this.doc.complete = 1
    }
  }
  private calcModelSize(doc: WpDocument, message: WpDocument) {
    let loadedPageIndex = 0
    if (message) {
      loadedPageIndex = doc.pages.length
      doc = this.doc = Object.assign(doc, message)
    }

    if (doc.ref) {
      let map = doc.refById = Object.create(null)
      for (let ref of doc.ref) {
        map[ref.id] = ref
      }
    }
    if (!doc.refById) doc.refById = Object.create(null)
    let attrById = doc.attrById = Object.create(null)
    for (let attr of doc.attr) {
      attrById[attr.id] = attr
    }

    let pageSize = doc.pagesize
    let width = pageSize.width, height = pageSize.height, maxPageWidth = width
    let special = Object.create(null)
    if (pageSize.special) {
      for (let size of pageSize.special) {
        special[size.index] = size
        if (maxPageWidth < size.width) maxPageWidth = size.width
      }
    }
    let docHeight = 0, count = doc.pageCount
    let gap = WpConst.PageGap, x = 0, y = gap
    let pages = doc.pages
    if (!message) {
      pages = doc.pages = []
    }
    else {
      y = doc.docHeight + gap
      docHeight = doc.docHeight
    }

    for (let i = loadedPageIndex; i < count; i++) {
      let page = Object.create(null) as Page
      page.index = i
      if (special[i]) {
        page.width = special[i].width
        page.height = special[i].height
      } else {
        page.width = width
        page.height = height
      }
      docHeight += page.height + gap
      pages[i] = page
      page.y = y
      page.x = (maxPageWidth - page.width) / 2
      y += page.height + gap
    }

    doc.maxPageWidth = maxPageWidth
    doc.docHeight = docHeight
    this.doc = doc
    // 判断是否能够复制
    this.isCopy = !doc.param.antiCopy ? true : false
    this.isPaintSelect = true
    // 判断是否需要显示备注
    if (doc.param.showComment) this.showComment = true
    // 判断是否需要显示画笔
    if (doc.param.showSign || doc.param.showSignature) this.showSign = false
    // 判断是否需要开启同步显示
    // if (doc.param.isSocket) this.isSocket = true
    // 更新pagecount前面的vlaue值，为第一页，有些浏览器刷新后没有置为第一页
    document.getElementById('activePage')['value'] = 1 + '';
    document.getElementById('nowpage').innerText = 1 + '';
    // 移动端不需要缩略图
    if (this.isMobile) $('#pg-leftpanel').remove()
    this.resizeWindow(1)
    if (!this.isMobile) this.thumbnail.reset(this, loadedPageIndex)
    this.resizeSidebar()
    // 判断一开始是否需要显示缩略图
    if (!doc.param.showThumb) {
      // requestAnimationFrame(() => this.isHideSidebar())
    }
  }

  determineVisiblePages() {
    let pages = this.doc.pages
    let page: Page, topy = this.scrolly, viewHeight = this.viewHeight, bottomy = topy + viewHeight, pagegap = PgConst.PageGap
    if (this.viewMode == ViewMode.Contious) {
      let startPageIndex = -1, endPageIndex = -1
      for (let i = 0; i < pages.length; i++) {
        page = pages[i]
        if (startPageIndex == -1 && (page.y - pagegap) * this.zoom * this.currentZoom <= topy && topy <= (page.y + page.height) * this.zoom * this.currentZoom) {
          startPageIndex = i
        }
        if (endPageIndex == -1 && (page.y - pagegap) * this.zoom * this.currentZoom <= bottomy && bottomy <= (page.y + page.height) * this.zoom * this.currentZoom) {
          endPageIndex = i
        }
        if (startPageIndex != -1 && endPageIndex != -1) {
          break
        }
      }
      if (startPageIndex == -1) startPageIndex = 0
      if (endPageIndex == -1) endPageIndex = pages.length - 1
      this.startPageIndex = startPageIndex
      this.endPageIndex = endPageIndex
      if (startPageIndex == 0 && endPageIndex == 0 && this.doc.docHeight < this.viewHeight) this.scrolly = 0
    }
  }


  public async scrollIntoView(page: Page, objectY: number) {
    let targetY = page.y + objectY
    let topy = this.scrolly, viewHeight = this.viewHeight / this.zoom, bottomy = topy + viewHeight
    if (targetY > topy && targetY < bottomy) {
      //obj is in view range,do nothing
      return
    }
    this.scrolly = targetY

    this.determineVisiblePages()
    this.disableScrollEvent = true
    this.scroller.scrollTop = targetY / this.doc.docHeight * this.scroller.scrollHeight
    await this.paint()
  }


  paint(loading?: boolean, c?: any) {
    let g = this.g
    g.clearRect(0, 0, this.canvas.width, this.canvas.height)
    if (this.viewMode == ViewMode.Contious) {
      g.save()
      g.setTransform(2 * this.zoom * this.currentZoom, 0, 0, 2 * this.zoom * this.currentZoom, 0, 0)
      g.translate(0, -this.scrolly / this.zoom / this.currentZoom)
      g.lineWidth = 1
      let start = this.startPageIndex, end = this.endPageIndex
      let pages = this.doc.pages, page: Page
      g.fillStyle = '#FFFFFF'
      g.strokeStyle = '#CECECE'
      for (let i = start; i <= end; i++) {
        page = pages[i]
        g.fillRect(page.x, page.y, page.width, page.height)
        g.strokeRect(page.x, page.y, page.width, page.height)
      }
      g.fillStyle = 'black'
      for (let i = start; i <= end; i++) {
        page = pages[i]
        if (page.state == LoadState.Ready) {
          g.save()
          //clip page
          g.beginPath()
          g.rect(page.x, page.y, page.width, page.height)
          g.clip()
          g.translate(page.x, page.y)
          if (!loading) {
            this.paintPage(g, page)
          }
          g.restore()
        } else if (page.state != LoadState.Loading) {
          page.state = LoadState.Loading
          this.loadPage(page, true)
        }
      }
      g.translate(0, this.scrolly / this.zoom / this.currentZoom)
      g.restore()
    } else {
      g.save()
      g.setTransform(2 * this.zoom * this.currentZoom, 0, 0, 2 * this.zoom * this.currentZoom, 0, 0)
      g.lineWidth = 1
      let pages = this.doc.pages, page: Page = pages[this.startPageIndex]
      let offy;
      if (this.showComment && !this.checkFull()) {
        offy = ((this.viewHeight - $('#comment').outerHeight()) / this.zoom / this.currentZoom - this.doc.pagesize.height) / 2
      } else {
        offy = (this.viewHeight / this.zoom / this.currentZoom - this.doc.pagesize.height) / 2
      }
      g.fillStyle = '#FFFFFF'
      g.strokeStyle = '#CECECE'
      g.fillRect(page.x, offy, page.width, page.height)
      g.strokeRect(page.x, offy, page.width, page.height)

      g.fillStyle = 'black'
      if (page.state == LoadState.Ready) {
        //clip page
        g.beginPath()
        g.rect(page.x, offy, page.width, page.height)
        g.clip()
        g.translate(page.x, offy)
        if (!loading) {
          this.paintPage(g, page, c)
        }
      } else if (page.state != LoadState.Loading) {
        page.state = LoadState.Loading
        this.loadPage(page, true)
      }
      g.restore()
    }

  }
  private player: Animation = new Animation()
  public paintPage(g: CanvasRenderingContext2D, page: Page, data?: any, isThumbnail?: boolean) {
    // 正常数据绘制
    let player = this.player
    //视频数据集合
    let videoList=[]
    for (let layer of page.layers) {
      for (let obj of layer) {
        if ((obj as any).ref !== undefined) {
          obj = this.doc.refById[(obj as any).ref]
          if (!obj) continue
        }
        if((obj as any).mediaPath) videoList.push((obj as any).mediaPath)
        // 处理动画，当处于放映状态的时候,当这个
        if (this.fullscreenState) {
          if ((obj as any).shapeID) {
            let animationState
            let animType
            let stressContent: AnimationContext
            let oldParaIdx: number
            let animTargetType
            let c: AnimationContext
            let animateContent: AnimInfo
            let isBackAfterPlay: boolean
            let animIdx: number
            let effectAfterPlay: number
            let shapeSameAnimation: number
            let oneSameTimeAimation: AnimationContext[] = []
            let groupSameTimeAimation: AnimationContext[] = []
            let ishasGroupSameTimeAimation: boolean
            for (let animateArray of (page as Slide).animation) {
              let flag: Boolean = false
              for (let animate of animateArray) {
                if ((obj as any).shapeID === animate.shapeID) {
                  // 段落文段动画的paraIdx >= 0
                  if ((Number(animate.paraIdx) >= 0) &&
                    (obj as TextObj).meta &&
                    (obj as TextObj).meta[2] !== animate.newParaIdx) continue;
                  // 此设置仅针对按整段发送和按几级段落发送，且有背景色的对象，因为背景色有单独的一个动画，此动画的animTargetType = -1；
                  if ((animate.animTargetType === -1 && animate.paraIdx === -1 && obj.t === 0 && (obj as TextObj).meta.length === 4 && (obj as TextObj).meta[1] !== 0 && !animate.isGroup) || (animate.paraIdx >= 0 && obj.t !== 0)) {
                    continue
                  }
                  animationState = animate.animationState
                  animTargetType = animate.animTargetType
                  animType = animate.animType
                  oldParaIdx = Number(animate.oldParaIdx)
                  isBackAfterPlay = animate.isBackAfterPlay
                  effectAfterPlay = animate.effectAfterPlay
                  animIdx = animate.animIdx
                  shapeSameAnimation = animate.shapeSameAnimation
                  if (animType === 1 || animType === 3) {
                    stressContent = animate.stressContent
                    // 针对一个对象会有多个动画的数据，譬如青蛙跳，stressContent的数据需要取最后一个shapeSameAnimation=2的记录数据
                    if (shapeSameAnimation === 1 && stressContent === undefined) {
                      for (let i = (page as Slide).animation.length - 1; i >= 0; i--) {
                        let animateArray1 = (page as Slide).animation[i];
                        for (let j = animateArray1.length - 1; j >= 0; j--) {
                          let animate2 = animateArray1[j];
                          if (animate2.shapeID === animate.shapeID && animate2.stressContent) {
                            stressContent = animate2.stressContent
                            break;
                          }
                        }
                        if (stressContent) break
                      }
                    }
                  }
                  // 当一个obj同时执行多个动画的时候，需要确定这种动画类型，处理数据获得同时进行动画数据
                  if (oneSameTimeAimation.length === 0 && animate.shapeSameAnimation && data && animateArray.length === data.length) {
                    let oneSameTimeAimationNeedClear = true;
                    for (let i = 0; i < animateArray.length; i++) {
                      if ((obj as any).shapeID === animateArray[i].shapeID) {
                        oneSameTimeAimation.push(data[i]);
                        if (animateArray[i].startCondition === 1) oneSameTimeAimationNeedClear = false
                      }
                    }
                    // 如果不存在动画同时进行的数据，归0，设置这个是为减少for循环
                    if (oneSameTimeAimationNeedClear) oneSameTimeAimation = [];
                    if (!oneSameTimeAimationNeedClear && !animate.oneSameTimeAimation) {
                      animate.oneSameTimeAimation = oneSameTimeAimation;
                    }
                  }
                  // 当一个obj同时执行多个动画，但是存在不同组别的时候，此时播放的动画如果上一个动画类型是1和3的话，需要在这个基础上播放
                  if (animate.groupSameAnimation === 1) {
                    for (let i = (page as Slide).animation.length - 1; i >= 0; i--) {
                      let animateArray3 = (page as Slide).animation[i];
                      for (let j = animateArray3.length - 1; j >= 0; j--) {
                        let animate3 = animateArray3[j];
                        if (animate3.shapeID === animate.shapeID && animate3.stressContent && animate3.groupSameAnimation === 2) {
                          if (animate3.oneSameTimeAimation) {
                            groupSameTimeAimation.concat(animate3.oneSameTimeAimation)
                          } else {
                            groupSameTimeAimation.push(animate3.stressContent)
                          }
                        }
                      }
                    }
                  }
                  // 为了处理同一个shape有多个动画
                  if (animate.animationState === 2) continue
                  flag = true;
                  break;
                }
              }
              if (flag) break;
            }
            // 当动画为多个的时候，paraIdx区分，当为一个动画的时候，paraIdx = -1；
            if (data) {
              c = data[oldParaIdx]
            }
            // 当这个数据时播放中的动画的时候
            if (animationState === 1 && c) {
              g.save()
              // 有几种动画类型需要动画播放在正常绘制之后
              if ((c.animInfo.animDir === 1 && c.animInfo.animType === 2 && c.animInfo.animIdx === 18) || //退出圆形扩展
                (c.animInfo.animDir === 0 && c.animInfo.animType === 0 && c.animInfo.animIdx === 18))  //圆形扩展
              {
                this.switchPaintType(g, page, obj, { c })
                // 当同一个obj同时有多个动画并行进行的时候
                if (oneSameTimeAimation.length > 0) {
                  for (let sameTimeAimation of oneSameTimeAimation) {
                    player.play(sameTimeAimation);
                  }
                } else if (groupSameTimeAimation.length > 0) {
                  for (let sameTimeAimation of oneSameTimeAimation) {
                    sameTimeAimation.count = sameTimeAimation.animInfo.endTime * 60
                    player.play(sameTimeAimation);
                  }
                  player.play(c);
                } else {
                  player.play(c);
                }
              } else {
                // 当同一个obj同时有多个动画并行进行的时候
                if (oneSameTimeAimation.length > 0) {
                  for (let sameTimeAimation of oneSameTimeAimation) {
                    player.play(sameTimeAimation);
                  }
                } else if (groupSameTimeAimation.length > 0) {
                  player.play(c);
                  for (let sameTimeAimation2 of groupSameTimeAimation) {
                    sameTimeAimation2.count = sameTimeAimation2.animInfo.endTime * 60
                    player.play(sameTimeAimation2);
                  }
                } else {
                  player.play(c);
                }
                this.switchPaintType(g, page, obj, { c });
              }
              g.restore()
            }
            //開始分情况进行动画过滤
            // 1. 正在播放中的动画是不用管的，在上面正在播放
            if (animationState === 1) continue
            // 2. 动画类型为进入，且动画还未播放的动画不需要绘制
            if (animationState === 0 && animType === 0) continue
            // 3. 动画类型为退出，且动画已经播放完毕的动画不需要绘制  
            // 3.1 动画isBackAfterPlay 为true 的时候，代表播放完后快退，不需要绘制
            if (animationState === 2 && (animType === 2 || isBackAfterPlay === true)) continue
            // 3.2 动画类型为 闪烁一次 的时候，播放完消失 
            if (animationState === 2 && animType === 0 && animIdx === 12) continue
            // 3.3 动画播放完后，设置为下次单击后隐藏
            if (animationState === 2 && (effectAfterPlay === 3 || effectAfterPlay === 4)) continue
            // 4. 动画类型为强调，且动画已经播放完毕的动画需要按最后一帧绘制
            if (animationState === 2 && (animType === 1 || animType === 3)) {
              g.save()
              if (oneSameTimeAimation.length > 0) {
                for (let sameTimeAimation of oneSameTimeAimation) {
                  sameTimeAimation.count = sameTimeAimation.animInfo.endTime * 60
                  player.play(sameTimeAimation);
                }
              } else if (groupSameTimeAimation.length > 0) {
                for (let sameTimeAimation3 of groupSameTimeAimation) {
                  sameTimeAimation3.count = sameTimeAimation3.animInfo.endTime * 60
                  player.play(sameTimeAimation3);
                }
                // stressContent.count = stressContent.animInfo.endTime * 60
                // player.play(stressContent)
              } else {
                stressContent.count = stressContent.animInfo.endTime * 60
                player.play(stressContent)
              }
              this.switchPaintType(g, page, obj, { c })
              g.restore()
              continue
            }
            // 5.针对一个对象会有多个动画的数据，譬如青蛙跳，需要单独加个标志，以区分这类数据 1:代表未播放 2:代表播放完毕
            if (animationState === 0 && (animType === 1 || animType === 3) && shapeSameAnimation && shapeSameAnimation === 1 && stressContent) {
              g.save()
              stressContent.count = stressContent.animInfo.endTime * 60
              player.play(stressContent)
              this.switchPaintType(g, page, obj, { c })
              g.restore()
              continue
            }
          }
        }
        this.switchPaintType(g, page, obj, { isThumbnail })
        //鼠标滚轮快速滑动，出现视频重叠
        setTimeout(() => {
          if((obj as any).mediaPath){
            if(videoList.length<$("video").length){
              for (let index = 0; index < $("video").length-videoList.length; index++) {
                $("video")[index].remove()
              }
            }
          }
        }, 0);
      }
    }
    // 更新备注内容
    if (this.showComment) {
      let comment = page.comment
      if (comment) {
        $('#comment').text(comment)
      } else {
        $('#comment').text('')
      }
    }
  }

  public switchPaintType(g: CanvasRenderingContext2D, page: Page, obj, set?: { isThumbnail?: boolean, c?: AnimationContext }) {
    switch (obj.t) {
      case ObjType.Text:
        this.paintText(g, page, obj as TextObj)
        break
      case ObjType.Image:
        this.paintImage(g, page, obj as ImageObj, set)
        break
      case ObjType.Path:
        this.paintPath(g, page, obj as PathObj)
        break
      case ObjType.Watermark:
        if ((obj as Watermark).text || (obj as Watermark).filePath) {
          if (!this.dyWaterMark.text) {
            this.paintTextWatermark(g, page, obj as Watermark)
          }
        }
        break
    }
    if (this.dyWaterMark.text) {
      this.paintTextWatermark(g, page, this.dyWaterMark)
    }
  }
  private paintText(g: CanvasRenderingContext2D, page: Page, obj: TextObj) {
    let v: string = obj.v + ''
    if (v == '\u0096') {
      v = ` `
    }
    g.save()
    let attr = this.doc.attrById[obj.aid || 0]
    if (!attr.gfont) attr.gfont = this.calcTextFont(attr)

    let old = g.fillStyle
    let ctm = obj.ctm, scalex = 1
    //dcc-257
    if (obj.clip) {
      let pathObj = Object.create(null)
      pathObj.v = obj.clip
      PathPainter.paintPath(g, pathObj)
      g.clip()
    }
    if (ctm) {
      g.transform(scalex = ctm[0], ctm[1], ctm[2], ctm[3], ctm[4], ctm[5])
    }
    if (attr.color) {
      if (g.strokeStyle === '#000001') {
        g.fillStyle = old
      } else {
        g.fillStyle = attr.color
      }
    }
    if (obj.alpha) {
      g.globalAlpha = obj.alpha * g.globalAlpha
    }
    if (g.strokeStyle === '#000004') {
      g.font = '900 ' + attr.gfont.replace('bold', '')
    } else {
      g.font = attr.gfont.replace('900', '')
    }

    let base = obj.y
    let charX = obj.charX;
    let charIndex = 1;
    let startX = obj.startX
    let charx = [];
    //special case:see java Character.isHighSurrogate()
    if (v.length == 2 && v.charCodeAt(0) >= 0xD800 && v.charCodeAt(0) < 0xDBFF + 1 && v.charCodeAt(1) >= 0xDC00 && v.charCodeAt(1) < 0xDFFF + 1) {
      g.fillText(v, obj.startX, base)
    } else {
      if (!charX) {
        g.fillText(v[0], obj.startX, base)
      }
      else {
        if (!obj.parsedCharx) {
          // g.fillText(v[0], obj.startX, base)
          charx.push(obj.startX)
          for (let i = 0; i < charX.length; i++) {
            if (i == charX.length - 1) {
              if (typeof charX[i] === "number") {
                // g.fillText(v[charIndex], charX[i] as number, base)
                charx.push(charX[i] as number)
              }
            }
            else {
              if (typeof charX[i + 1] === "number") {
                startX = <number>charX[i]
                // g.fillText(v[charIndex], startX, base)
                charx.push(startX)
                charIndex++
              }
              else {
                let parseint = parseInt
                let num: number = parseint((<string>charX[i + 1]).replace("g", ""))
                for (let j = 1; j < num + 1; j++) {
                  startX += <number>charX[i]
                  // g.fillText(v[charIndex], startX, base)
                  charx.push(startX)
                  charIndex++
                }
                i++
              }
            }
          }
          obj.parsedCharx = charx
        }
        if (v.length > 1000) {
          g.fillText(v, obj.startX, base);
        }
        else {

          for (let i = 0; i < v.length; i++) {
            if (i < v.length - 1) {
              g.fillText(v[i], obj.parsedCharx[i], base, obj.parsedCharx[i + 1] - obj.parsedCharx[i])
            }
            else {
              g.fillText(v[i], obj.parsedCharx[i], base)
            }
          }
        }
      }
    }
    g.restore()
    g.fillStyle = old
    // g.globalAlpha = 1
  }
  private paintTextWatermark(g: CanvasRenderingContext2D, page: Page, obj: Watermark) {
    let screenWidth = this.parentWidth;
    let screenHeight = this.parentHeight;
    if (obj.text) {
      let v = obj.text
      let strArr;
      if (v.indexOf('<br/>') > -1) {
        strArr = v.split('<br/>')
      }
      let font = obj.fontSize + "px " + obj.family + ''
      g.font = font
      let textWidth = g.measureText(v).width
      let realWidth = 0;
      if (strArr) {
        for (let i = 0; i < strArr.length; i++) {
          if (g.measureText(strArr[i]).width > realWidth) {
            realWidth = g.measureText(strArr[i]).width
          }
        }
        textWidth = realWidth
      }
      let width = textWidth, height = strArr ? obj.fontSize * strArr.length : obj.fontSize
      if (obj.isTile) {
        width += obj.textIndent_x ? obj.textIndent_x : obj.textIndent
        height += obj.textIndent_y ? obj.textIndent_y : obj.textIndent
        let canvas: HTMLCanvasElement = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        canvas.style.width = width + 'px'
        canvas.style.height = height + 'px'
        let tmpg: CanvasRenderingContext2D = canvas.getContext('2d')
        Util.resizeCanvas(canvas, width, height, 2)
        tmpg.font = font // `${watermark.fontSize}px ${watermark.family}`
        tmpg.fillStyle = obj.color
        tmpg.globalAlpha = obj.alpha
        g.translate(page.width / 2, page.height / 2)
        g.rotate(obj.angle * Math.PI / 180)
        tmpg.textBaseline = 'bottom'
        if (strArr) {
          for (let i = 0; i < strArr.length; i++) {
            tmpg.fillText(strArr[i], (width - g.measureText(strArr[i],).width) / 2, obj.fontSize * (1 + i))
          }
        }
        else {
          tmpg.fillText(v, (width - textWidth) / 2, height)
        }
        g.fillStyle = g.createPattern(canvas, "repeat")
        g.fillRect(-screenWidth, -screenHeight, screenWidth * 2, screenHeight * 2)
        g.rotate(-obj.angle * Math.PI / 180)
        g.translate(-page.width / 2, -page.height / 2)
      }
      else {
        if (obj.txtX == 0 || obj.txtY == 0
          || obj.txtX > 0 || obj.txtY > 0) {
          // 按picx 和picy来
          g.save()
          g.translate(obj.txtX, obj.txtY)
          g.rotate(obj.angle * Math.PI / 180)
          g.globalAlpha = 1 - obj.alpha
          g.font = font
          g.fillStyle = obj.color
          if (strArr) {
            for (let i = 0; i < strArr.length; i++) {
              g.fillText(strArr[i], 0, obj.fontSize * i)
            }
          }
          else {
            g.fillText(v, 0, 0)
          }
          g.restore()
        } else {
          // 居中
          g.save()
          g.translate(page.width / 2 - width / 2, page.height / 2 - height / 2)
          g.rotate(obj.angle * Math.PI / 180)
          g.globalAlpha = 1 - obj.alpha
          g.font = font
          g.fillStyle = obj.color
          if (strArr) {
            for (let i = 0; i < strArr.length; i++) {
              g.fillText(strArr[i], - width / 2, height / 2 + obj.fontSize * i)
            }
          }
          else {
            g.fillText(v, - width / 2, height / 2)
          }
          g.restore()
        }
      }
    }
    else if (obj.filePath) {
      let imgData: ImageObj = Object.create(null)
      imgData.v = obj.filePath
      this.loadImage(page, imgData)
      let data = this.loadingImages[obj.filePath]
      if (data.img.complete) {
        let width = obj.w > 0 ? obj.w : data.img.width
        let height = obj.h > 0 ? obj.h : data.img.height
        if (obj.isTile) {
          let canvas = document.createElement('canvas')
          canvas.width = width
          canvas.height = height
          canvas.style.width = width + 'px'
          canvas.style.height = height + 'px'

          let tmpg: CanvasRenderingContext2D = canvas.getContext('2d')
          g.translate(page.width / 2, page.height / 2)
          g.rotate(obj.angle * Math.PI / 180)
          tmpg.globalAlpha = obj.alpha
          tmpg.drawImage(data.img, 0, 0, width, height)
          g.fillStyle = g.createPattern(canvas, "repeat")
          g.fillRect(-screenWidth, -screenHeight, screenWidth * 2, screenHeight * 2)
          g.rotate(-obj.angle * Math.PI / 180)
          g.translate(-width / 2, -height / 2)
        }
        else {
          if (obj.picX == 2147483647 || obj.picY == 2147483647) {
            // 居中
            g.save()
            g.translate(page.width / 2 - width / 2, page.height / 2 - height / 2)
            g.rotate(obj.angle * Math.PI / 180)
            g.globalAlpha = 1 - obj.alpha
            g.drawImage(data.img, 0, 0, width, height)
            g.restore()
          } else {
            // 按picx 和picy来
            g.save()
            g.translate(obj.picX, obj.picY)
            g.rotate(obj.angle * Math.PI / 180)
            g.globalAlpha = 1 - obj.alpha
            g.drawImage(data.img, 0, 0, width, height)
            g.restore()
          }
        }
      }
    }

  }
  private calcTextFont(attr: TAttr): string {
    let s = ''
    if (attr.b) s += 'bold '
    if (attr.i) s += 'italic '
    s += attr.size + 'px '
    s += attr.font
    return s
  }
  private paintImage(g: CanvasRenderingContext2D, page: Page, obj: ImageObj, set: { isThumbnail?: boolean, c?: AnimationContext }) {
    // 关于音频和视频文件,在每一页都生成
    let mediaPath = obj.mediaPath
    // if (!set.isThumbnail && mediaPath && !this.isMobile) {
    //   setTimeout(() => {
    //     this.createMedia(mediaPath, obj)
    //   }, 0);
    // }
    if (!set.isThumbnail && mediaPath) {
      setTimeout(() => {
        this.createMedia(mediaPath, obj)
      }, 0);
    }
    if ((obj.v.match(/GIF/) || obj.v.match(/gif/)) && !set.isThumbnail && obj.data) {
      // 全屏型gif就不显示了
      if (obj.rect[2] * this.zoom < g.canvas.clientWidth - 20 && obj.rect[3] * this.zoom < g.canvas.clientHeight - 20) {
        if ((set.c && set.c.animInfo.endTime * 60 <= set.c.count) || !set.c) {
          this.createGif(obj.data.path, obj)
          return
        }
      }

    }
    // 生成超链接的图片
    if (!set.isThumbnail && obj.hyperlink && !this.isMobile && this.fullscreenState) {
      this.createHyperImage(obj)
      return
    }
    let data = obj.data
    if (!data) {
      data = this.loadingImages[obj.v]
      if (data && data.state == LoadState.Ready) {
        obj.data = data
        obj.state = LoadState.Ready
      }
    }
    if (obj.alpha) {
      g.globalAlpha = obj.alpha * g.globalAlpha
    }
    if (obj.state == LoadState.Ready) {
      g.save()

      let ctm = obj.ctm
      //dcc-203
      if (obj.clip) {
        let pathObj = Object.create(null)
        pathObj.v = obj.clip

        PathPainter.paintPath(g, pathObj)
        g.clip()
      }
      if (ctm) {
        g.transform(ctm[0], ctm[1], ctm[2], ctm[3], ctm[4], ctm[5])
      }
      let rect = obj.rect
      if (obj.alpha) g.globalAlpha = obj.alpha
      if (obj.repeat) {
        g.fillStyle = g.createPattern(obj.data.img, 'repeat')
        g.fillRect(rect[0], rect[1], rect[2], rect[3])
      }
      else {
        g.drawImage(obj.data.img, rect[0], rect[1], rect[2], rect[3])
      }


      g.restore()
      g.globalAlpha = 1
    } else if (obj.state != LoadState.Loading) {
      obj.state = LoadState.Loading
      this.loadImage(page, obj)
    }
  }
  private paintPath(g: CanvasRenderingContext2D, page: Page, obj: PathObj) {
    g.save()
    let ctm = obj.ctm
    // if (ctm) {
    //     g.transform(ctm[0], ctm[1], ctm[2], ctm[3], ctm[4], ctm[5])
    // }
    if (obj.clip) {
      let pathObj = Object.create(null)
      pathObj.v = obj.clip
      PathPainter.paintPath(g, pathObj)
      g.clip()
    }
    PathPainter.paintPath(g, obj)
    g.lineWidth = obj.lineWidth
    g.lineCap = obj.lineCap
    // if (g.globalAlpha && g.globalAlpha > 0) {
    //     g.globalAlpha = obj.alpha ? obj.alpha * g.globalAlpha : g.globalAlpha
    // }
    if (obj.dashArr) {
      g.setLineDash(obj.dashArr)
    }
    switch (obj.type) {
      case 1:
        if (this.fullscreenState && (g.strokeStyle === '#000001' || g.strokeStyle === '#000002' || g.strokeStyle === '#00000b')) {
          g.strokeStyle = g.fillStyle
          g.stroke()
        } else {
          g.strokeStyle = obj.paintInfo.replace('rgb(', 'rgba(')
          g.stroke()
        }
        break;
      case 2:
        if (this.fullscreenState && (g.strokeStyle === '#000001' || g.strokeStyle === '#000002' || g.strokeStyle === '#00000a')) {
          g.fill()
        } else {
          g.fillStyle = obj.paintInfo.replace('rgb(', 'rgba(')
          g.fill()
        }
        break;
      case 3:
        g.translate(obj.rect[0], obj.rect[1])
        let imagePath = obj.paintInfo
        let imageState = this.loadingImages[imagePath]
        if (imageState) {
          if (imageState.img.width > obj.rect[2]
            || imageState.img.height > obj.rect[3]) {
            g.scale(obj.rect[2] / imageState.img.width, obj.rect[3] / imageState.img.height)
          }
          g.strokeStyle = g.createPattern(imageState.img, 'repeat')
          g.stroke()
        }
        else {
          let img: ImageObj = Object.create(null)
          img.v = imagePath
          this.loadImage(page, img)
        }
        g.translate(-obj.rect[0], -obj.rect[1])
        break;
      case 4:
        g.translate(obj.rect[0], obj.rect[1])
        let imagePath4 = obj.paintInfo
        let imageState4 = this.loadingImages[imagePath4]
        if (imageState4) {
          if (ctm) {
            g.scale(ctm[0], ctm[1])
          }
          g.fillStyle = g.createPattern(imageState4.img, 'repeat')
          g.fill()
        }
        else {
          let img: ImageObj = Object.create(null)
          img.v = imagePath4
          this.loadImage(page, img)
        }
        g.translate(-obj.rect[0], -obj.rect[1])
        break;
      case 5:
        paintPathGradient1(g, obj, obj.rect, obj.v, 'stroke')
        break;
      case 6:
        paintPathGradient1(g, obj, obj.rect, obj.v, 'fill')
        break;
      case 7:
        paintPathGradient2(g, obj, obj.rect, obj.v, 'stroke')
        break;
      case 8:
        paintPathGradient2(g, obj, obj.rect, obj.v, 'fill')
        break;
      default:
        break;
    }

    g.restore()
    g.lineWidth = 0.5
    g.setLineDash([])
    // g.fillStyle = 'white'
    // g.strokeStyle = 'white'
  }
  // 获取音视频的地址
  public mediaPath: string[]
//   public getMediaPath() {
//     let pathArray = [];
//     let mediaPath = new Set(this.mediaPath);
//     mediaPath.forEach(value => {
//       pathArray.push(value)
//     })
//     return pathArray;
//   }
  // 生成音频视频
  private createMedia(mediaPath: string, obj: ImageObj) {
    // 判断是音频还是视频
    let endString = mediaPath.split('.')[1];
    let offy;
    if (this.showComment && !this.checkFull()) {
      offy = ((this.viewHeight - $('#comment').outerHeight()) / this.zoom / this.currentZoom - this.doc.pagesize.height) / 2;
    } else {
      offy = (this.viewHeight / this.zoom / this.currentZoom - this.doc.pagesize.height) / 2;
    }
    let mediaId = mediaPath.split('.')[0].split('/')[1] + mediaPath.split('.')[1];
    let zoom = this.zoom * this.currentZoom;
    if (/(mp3|Wav|Ogg)/gi.test(endString)) {
      //  + this.suffixUrl是为了解决服务于权限控制的
      let audioSrc = this.pageUrlRoot + obj.mediaPath + this.suffixUrl
      let audioWidth = 300;
      let audioHeight = 30;
      if ($('#' + mediaId).length === 0) {
        $('<audio src="' + audioSrc + '" controls="controls" id="' + mediaId + '"></audio>').css({
          "position": "absolute",
          "left": (obj.rect[0] + obj.rect[2] / 2) * zoom - audioWidth / 2 + "px",
          "top": (obj.rect[1] + offy + obj.rect[3]) * zoom + "px",
          "width": audioWidth + "px",
          "height": audioHeight + "px"
        }).appendTo("#dcs-pgreader-canvaswrapper")
      }
      // 阻止事件冒泡
      $(`#${mediaId}`).click(function (e) {
        e.stopPropagation();
      })
    } else if (/(MP4|WebM|Ogg)/gi.test(endString)) {
       //  + this.suffixUrl是为了解决服务于权限控制的
       let videoSrc = this.pageUrlRoot + obj.mediaPath + this.suffixUrl
       let videoPicSrc = this.pageUrlRoot + obj.v + this.suffixUrl //视频缩略图
       // 将当前页的视频数据存储
       this.mediaPath && this.mediaPath.push(videoSrc);
       if ($('#' + mediaId).length === 0) {
         $('<video src="' + videoSrc + '" controls="controls" id="' + mediaId + '"controlslist="nodownload" preload="none"  poster="'+videoPicSrc+'"></video>').css({
           "position": "absolute",
           "left": obj.rect[0] * zoom + "px",
           "top": (obj.rect[1] + offy) * zoom + "px",
           "width": obj.rect[2] * zoom + "px",
           "height": obj.rect[3] * zoom + "px",
           "backgroundColor": "black"
         }).appendTo("#dcs-pgreader-canvaswrapper")
       }
 
       // 如果是ipad端，需要向客户端发送地址
       $(`#${mediaId}`).click(function (e) {
         e.stopPropagation();
       })
       $(`#${mediaId}`)[0].addEventListener('play', (e) => {
         if (this.isMobile) {
           $(`#${mediaId}`)[0].pause();
           (window as any).webkit.messageHandlers.JKEventHandler.postMessage(JSON.stringify({
             messageType: 7,
             shareUrl: encodeURI(videoSrc)
           }));
         }
       })
     }
  }

  public killMedia() {
    // 首先删除页面存在的音频和视频
    $('video, audio').remove();
    $('.canvasGif').remove()
    $('.canvasHyperImage').remove();
  }

  // 生成gif
  private createGif(imgPath: string, obj: ImageObj) {
    let offy
    if (this.showComment && !this.checkFull()) {
      offy = ((this.viewHeight - $('#comment').outerHeight()) / this.zoom / this.currentZoom - this.doc.pagesize.height) / 2
    } else {
      offy = (this.viewHeight / this.zoom / this.currentZoom - this.doc.pagesize.height) / 2
    }
    let imgId = obj.shapeID + '' + obj.rect[0] + obj.rect[1]
    let zoom = this.zoom * this.currentZoom
    //  + this.suffixUrl是为了解决服务于权限控制的
    let imgsrc = this.pageUrlRoot + obj.data.path + this.suffixUrl
    let imgWidth = obj.rect[2] * zoom
    let imgHeight = obj.rect[3] * zoom
    if ($('#' + imgId).length === 0) {
      $('<img src="' + imgsrc + '" id="' + imgId + '" class="canvasGif">').css({
        "position": "absolute",
        "left": (obj.rect[0] + obj.rect[2] / 2) * zoom - imgWidth / 2 + "px",
        "top": (obj.rect[1] + offy) * zoom + "px",
        "width": imgWidth + "px",
        "height": imgHeight + "px"
      }).appendTo('#dcs-pgreader-canvaswrapper')
      if (obj.ctm) {
        $('#' + imgId).css({
          "transform": `matrix(${obj.ctm[0]},${obj.ctm[1]},${obj.ctm[2]},${obj.ctm[3]},0,0)`
        })
      }
    } else {
      $('#' + imgId).css({
        "left": (obj.rect[0] + obj.rect[2] / 2) * zoom - imgWidth / 2 + "px",
        "top": (obj.rect[1] + offy) * zoom + "px",
        "width": imgWidth + "px",
        "height": imgHeight + "px"
      })
    }
  }

  // 生成超链接的图片
  private createHyperImage(obj: ImageObj) {
    let offy;
    if (this.showComment && !this.checkFull()) {
      offy = ((this.viewHeight - $('#comment').outerHeight()) / this.zoom / this.currentZoom - this.doc.pagesize.height) / 2;
    } else {
      offy = (this.viewHeight / this.zoom / this.currentZoom - this.doc.pagesize.height) / 2;
    }
    let zoom = this.zoom * this.currentZoom
    //  + this.suffixUrl是为了解决服务于权限控制的
    let imgsrc = this.pageUrlRoot + obj.data.path + this.suffixUrl
    let imgWidth = obj.rect[2] * zoom
    let imgHeight = obj.rect[3] * zoom
    if (obj.hyperlinkType == 1) {
      if ($(`#${obj.rect[0] + obj.rect[1] + obj.rect[2] + obj.rect[3]}`).length === 0) {
        $(`<img src="${imgsrc}" id="${obj.rect[0] + obj.rect[1] + obj.rect[2] + obj.rect[3]}" class="canvasHyperImage" onclick='reader.gotoPage(${parseInt(obj.hyperlink)})','_blank','width=${window.innerWidth * 0.9},height=${window.innerHeight * 0.8},top=${window.innerHeight * 0.1},left=${window.innerWidth * 0.05},menubar=no,toolbar=no,status=no,scrollbars=yes')>`).css({
          "position": "absolute",
          "cursor": "pointer",
          "left": (obj.rect[0] + obj.rect[2] / 2) * zoom - imgWidth / 2 + "px",
          "top": (obj.rect[1] + offy) * zoom + "px",
          "width": imgWidth + "px",
          "height": imgHeight + "px"
        }).appendTo('#dcs-pgreader-canvaswrapper')
      }
    } else if (obj.hyperlinkType == 0) {
      if ($(`#${obj.rect[0] + obj.rect[1] + obj.rect[2] + obj.rect[3]}`).length === 0) {
        $(`<img src="${imgsrc}" class="canvasHyperImage" onclick=window.open('${obj.hyperlink}','_blank','width=${window.innerWidth * 0.9},height=${window.innerHeight * 0.8},top=${window.innerHeight * 0.1},left=${window.innerWidth * 0.05},menubar=no,toolbar=no,status=no,scrollbars=yes')>`).css({
          "position": "absolute",
          "cursor": "pointer",
          "left": (obj.rect[0] + obj.rect[2] / 2) * zoom - imgWidth / 2 + "px",
          "top": (obj.rect[1] + offy) * zoom + "px",
          "width": imgWidth + "px",
          "height": imgHeight + "px"
        }).appendTo('#dcs-pgreader-canvaswrapper')
      }
    }
  }

  private loadImage(page: Page, obj: ImageObj) {
    let loading = this.loadingImages
    if (loading[obj.v]) return
    let imgData = Object.create(null) as RemoteImageData
    imgData.path = obj.v
    loading[imgData.path] = imgData

    // let resp = await axios.get(this.pageUrlRoot + imgData.path, { responseType: 'blob' })
    let img = imgData.img = new Image()
    img.onload = () => {
      imgData.state = LoadState.Ready
      this.triggerRepaint(page)
    }
    img.src = this.pageUrlRoot + imgData.path + this.suffixUrl// URL.createObjectURL(resp.data)
  }

  private loadPathImage(obj: PathObj, resolve) {
    let loading = this.loadingImages
    let imgData = Object.create(null) as RemoteImageData
    imgData.path = obj.paintInfo
    loading[imgData.path] = imgData
    let img = imgData.img = new Image()
    img.onload = () => {
      imgData.state = LoadState.Ready
      if (resolve) resolve()
    }
    img.onerror = () => {
      imgData.state = LoadState.Ready
      if (resolve) resolve()
    }
    img.src = this.pageUrlRoot + imgData.path + this.suffixUrl// URL.createObjectURL(resp.data)
  }

  private triggerRepaint(page: Page) {
    if (page.index >= this.startPageIndex && page.index <= this.endPageIndex) {
      //the page is in viewport,trigger repaint
      requestAnimationFrame(() => this.paint())
    }
  }
  public async loadPage(page: Page, repaint?: boolean) {
    if (page.state == LoadState.Ready) return
    let resp = await axios.get(this.pageUrlRoot + page.index + '.json' + this.suffixUrl)
    Object.assign(page, resp.data)
    page.state = LoadState.Ready

    // animate data
    let groups = Object.create(null)
    //collect page  all text(only layer[1] text is collected)
    let pageText = '', linemap = Object.create(null), charx: number[], line: Line, v: string, char: Char, phrase: Phrase
    if (!page.layers[1]) return
    for (let obj of page.layers[1]) {
      switch (obj.t) {
        case ObjType.Text:
          charx = (obj as TextObj).charx
          line = linemap[(obj as TextObj).y]
          if (!line) {
            line = Object.create(null)
            line.y = (obj as TextObj).y
            line.height = (obj as TextObj).h
            line.chars = []
            line.phrases = []
            linemap[(obj as TextObj).y] = line
          } else {//同一行字符，height取高度最高的
            if (line.height < (obj as TextObj).h) {
              line.height = (obj as TextObj).h
            }
          }
          let charX = (obj as TextObj).charX
          let charIndex = 1;
          let startX = (obj as TextObj).startX
          v = (obj as TextObj).v as string
          char = Object.create(null)
          if (v) {
            char.t = v[0]
          }
          char.x = startX
          phrase = Object.create(null)
          phrase.t = obj.v
          phrase.x = startX
          if ((obj as TextObj).hyperlinkAddress) {
            char.hyperlinkAddress = (obj as TextObj).hyperlinkAddress
          }
          char.width = this.lastCharWidth((obj as TextObj).h)
          line.chars.push(char)

          if (charX) {
            for (let i = 0; i < charX.length; i++) {
              if (i == charX.length - 1) {
                if (typeof charX[i] === "number") {
                  char = Object.create(null)
                  if ((obj as TextObj).hyperlinkAddress) {
                    char.hyperlinkAddress = (obj as TextObj).hyperlinkAddress
                  }
                  char.t = v[charIndex]
                  char.x = charX[i] as number
                  char.width = this.lastCharWidth((obj as TextObj).h)
                  line.chars.push(char)
                }
              }
              else {
                if (typeof charX[i + 1] === "number") {
                  char = Object.create(null)
                  if ((obj as TextObj).hyperlinkAddress) {
                    char.hyperlinkAddress = (obj as TextObj).hyperlinkAddress
                  }
                  startX = <number>charX[i]
                  char.t = v[charIndex]
                  char.x = startX
                  char.width = <number>charX[i + 1] - <number>charX[i]
                  line.chars.push(char)
                  charIndex++
                }
                else {
                  let num: number = parseInt((<string>charX[i + 1]).replace("g", ""))
                  for (let j = 1; j < num + 1; j++) {
                    char = Object.create(null)
                    if ((obj as TextObj).hyperlinkAddress) {
                      char.hyperlinkAddress = (obj as TextObj).hyperlinkAddress
                    }
                    startX += <number>charX[i]
                    char.t = v[charIndex]
                    char.x = startX
                    char.width = <number>charX[i]
                    line.chars.push(char)
                    charIndex++
                  }
                  i++
                }
              }
            }

            let last = charX.length - 1

            if (typeof charX[last] === 'number') {
              phrase.width = <number>charX[last] - phrase.x + this.lastCharWidth((obj as TextObj).h)
            }
            else {
              let num: number = parseInt((<string>charX[last]).replace("g", ""))
              if (last !== 1) {
                phrase.width = <number>charX[last - 2] - phrase.x + <number>charX[last - 1] * (num + 1)
              } else {
                phrase.width = <number>charX[last - 1] * (num + 1)
              }

            }
          } else {
            if (obj.ctm && obj.ctm[0] && obj.ctm[0] !== 1) {
              phrase.width = this.lastCharWidth(obj.ctm[0] * (obj as any).h)
            } else {
              phrase.width = char.width
            }
          }

          if ((obj as TextObj).meta) {
            phrase.meta = (obj as TextObj).meta
            if ((obj as TextObj).meta[0] < 0) {
              line.type = -1
            }
          }
          line.phrases.push(phrase)

          pageText += (obj as TextObj).v
          break
      }
      // 如果此数据有动画数据
      if (obj.shapeID) {
        if (!groups[obj.shapeID]) {
          groups[obj.shapeID] = []
          groups[obj.shapeID].push(obj)
        } else {
          groups[obj.shapeID].push(obj)
        }
      }

    }
    let lines = []
    for (let y in linemap) {
      //起始字符位置
      linemap[y].x = linemap[y]['chars'][0].x
      //因为上面的逻辑取宽度是错误的，所以需要重新计算宽度,最后一宽度已经在上面计算过了，所以不用重新计算了
      let pre: Char
      for (let i = 0; i < linemap[y]['chars'].length; i++) {
        if (pre) pre.width = linemap[y]['chars'][i].x - pre.x
        pre = linemap[y]['chars'][i]
      }
      //整个line的宽度
      linemap[y].width = linemap[y]['chars'][linemap[y]['chars'].length - 1].x - linemap[y]['chars'][0].x + linemap[y]['chars'][linemap[y]['chars'].length - 1].width
      lines.push(linemap[y])
    }
    lines.sort(this.yComparator)
    page.lines = lines
    page.text = pageText;
    // this.dumpLines(lines)
    // 处理动画数据
    for (let shapeId in groups) {
      let paraDataList = []; // 用来临时存para的数据
      let lastEmphAttr = 0; // 临时记录上一次缩放比 2021.11.03
      for (let animationData of (page as any).animation) {
        if (Number(shapeId) === animationData.shapeID) {
          let groupData = groups[shapeId]
          let paraIdx = Number(animationData.paraIdx)
          // 当动画作为文本段落发送的时候，每个动画的每个段落的区域不一样，groupdata数据需要对应相对应的para数据
          if (paraIdx >= 0) {
            if (paraDataList.length === 0) paraDataList = this.paraDataSolve(groupData)
            let paraData = paraDataList[paraIdx];
            if (!paraData) {
              animationData.error = true
            } else {
              // animationData.shape = this.solveAimate(paraData)
              animationData.shape = this.solveRectAimate(animationData.rect)
              animationData.textInfo = this.solveTextInfo(this.solveAimate(paraData));
            }
            animationData.newParaIdx = Number(animationData.paraIdx) + Number(this.paraIdMin)
          } else {
            animationData.shape = this.solveRectAimate(animationData.rect)
          }
          //  计算shape的direct，需要分情况处理
          if (JSON.stringify(animationData.emphAttr) !== '{}') {
            animationData.direct = [animationData.emphIdx, animationData.emphAttr]
            // 如果是缩放需要记住上一次的缩放状态 2021.11.03
            if (animationData.animType === 1 && animationData.animIdx === 0) {
              if (lastEmphAttr) {
                animationData.direct[2] = lastEmphAttr
              }
              lastEmphAttr = animationData.emphAttr
            }
          } else {
            animationData.direct = animationData.animDir
          }
          // endTime 重新赋值，动画播放的时间是endTime - startTime
          if (Number(animationData.startTime) < Number(animationData.endTime)) {
            animationData.endTime = Number(animationData.endTime) - Number(animationData.startTime)
            // 随机动画解析出来的时候时间实在是太短,完全不够时间播放
            if (animationData.animIdx === 16 && animationData.endTime < 0.5) {
              animationData.endTime = 0.5
            }
          }
          // 当为音频数据的时候，目前现将此数据处理为error数据，不做动画播放
          if (animationData.animType === 4 && !animationData.error) animationData.error = true
        } else {
          // 上面的内容不break是为了一个动画对象可能会出现多个动画
          continue
        }
      }
    }
    // 针对一个对象会有多个动画的数据，譬如一个物体移动到一个位置，然后再进行旋转，需要单独加个标志，以区分这类数据
    for (let i = 0; i < (page as any).animation.length; i++) {
      let animationData1 = (page as any).animation[i];
      let shapeId = animationData1.shapeID
      if (animationData1.shapeSameAnimation) {
        continue
      }
      for (let j = i + 1; j < (page as any).animation.length; j++) {
        let animationData2 = (page as any).animation[j];
        let shapeId2 = animationData2.shapeID
        if (shapeId === shapeId2) {
          animationData1.groupSameAnimation = animationData2.groupSameAnimation = 1
        }
      }
    }

    // 考虑动画存在同时进行的情况，因此先区分每个动画，将同时进行的动画归位一组
    let newAnimation = []
    let everyData = []
    for (let i = 0; i < (page as Slide).animation.length; i++) {
      let animationData = (page as Slide).animation[i];
      everyData.push(animationData);
      if (i === (page as Slide).animation.length - 1) {
        newAnimation.push(everyData);
        break;
      }
      let animationDataNext = (page as any).animation[i + 1];
      if (animationDataNext.startCondition === 0 || animationDataNext.startCondition === 2) {
        newAnimation.push(everyData);
        everyData = [];
      }
    }

    // 针对一个对象会有多个动画的数据，譬如青蛙跳，需要单独加个标志，以区分这类数据
    for (let m = 0; m < newAnimation.length; m++) {
      for (let i = 0; i < newAnimation[m].length; i++) {
        let animationData1 = newAnimation[m][i];
        let shapeId = animationData1.shapeID
        if (animationData1.shapeSameAnimation) {
          continue
        }
        for (let j = i + 1; j < newAnimation[m].length; j++) {
          let animationData2 = newAnimation[m][j];
          let shapeId2 = animationData2.shapeID
          if (shapeId === shapeId2) {
            animationData1.shapeSameAnimation = animationData2.shapeSameAnimation = 1
          }
        }
      }
    }

    // 如果动画数据出现错误数据的话，那么删除此动画数据,同时重新赋值paraId
    for (let i = newAnimation.length - 1; i >= 0; i--) {
      let animationDataArray = newAnimation[i];
      for (let n = animationDataArray.length - 1; n >= 0; n--) {
        let animationData = animationDataArray[n];
        // 重新赋值paraId
        animationData.oldParaIdx = n;
        if (animationData.error) animationDataArray.splice(n, 1);
      }
      if (animationDataArray.length === 0) newAnimation.splice(i, 1)
    }
    // (page as Slide).animation 重新赋值，结构变为数组，为后续动画并行做处理
    (page as Slide).animation = newAnimation
    if (repaint) {
      this.triggerRepaint(page)
    }
    // 专门为网易云星设置的播放状态,当第一页的数据处理完后，就可以直接进入播放状态了
    if (page.index === 0) {
      dispatchEvent(new CustomEvent('pagedata', { detail: true }))
    }
  }
  private dumpLines(lines) {
    console.log('lines:', lines.length)
    for (let i = 0; i < lines.length; i++) {
      let line = lines[i]
      let linetext = ''
      for (let ch of line.chars) {
        linetext += ch.t
      }
      console.log('line', i, linetext)
    }
  }
  private yComparator(o1, o2) {
    if (o1.y > o2.y) return 1
    else if (o1.y < o2.y) return -1
    return 0
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////// 
  /////////////////////////////////选取复制 start/////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////// 
  private onMouseDown(e: MouseEvent) {
    if (e.button == 0) {
      this.isMouseDown = true
      this.caret1 = Object.create(null)
      this.caret2 = Object.create(null)
      if (this.hyperLink(e)) return
      this.doClick(e, this.caret1)
      this.paintCaret()
    }
  }
  private onContextMenu(e: MouseEvent) {
    e.preventDefault()
    if (this.isCopy) {
      //创建右键菜单
      if (this.caret1.page && this.caret2.page && !this.checkFull()) {
        this.createMenu()
      } else {
        this.deleteMenu()
      }
    }
    // // 当全屏状态的时候，需要右键上下页控制和结束放映状态
    // if (this.checkFull()) {
    //     this.createFullMenu();
    // }
  }
  // 超链接
  private hyperLink(e: MouseEvent) {
    let x = e.offsetX, y = e.offsetY
    let page = this.getClickPage(y)
    if (!page) return
    let lines = page.lines
    // 通过y来判断所在行，但是有的行是叠在一行的,所以选择后需要再次筛选
    let temp = []
    let offy;
    if (this.showComment && !this.checkFull()) {
      offy = (this.viewHeight - this.doc.pagesize.height * this.zoom * this.currentZoom - $('#comment').outerHeight()) / 2
    } else {
      offy = (this.viewHeight - this.doc.pagesize.height * this.zoom * this.currentZoom) / 2
    }
    for (let i = 0; i < lines.length; i++) {
      let line = lines[i]
      if ((line.y + this.calTextHeightOffset(line.height)) * this.zoom * this.currentZoom + offy >= y && (line.y - line.height + this.calTextHeightOffset(line.height)) * this.zoom * this.currentZoom + offy <= y) {
        if (line.x * this.zoom * this.currentZoom < x && (line.x + line.width) * this.zoom * this.currentZoom > x) {
          temp.push({
            line,
            i
          })
        }
      }
    }
    temp.sort((a, b) => {
      return b.line.x - a.line.x
    })
    if (temp.length > 0) {
      return this.judgeClick(temp[0].line, x)
    }
  }

  private judgeClick(line, x) {
    let chars: Char[] = line.chars
    for (let i = 0; i < chars.length; i++) {
      let char = chars[i]
      if (char.x * this.zoom * this.currentZoom <= x && (char.x + char.width) * this.zoom * this.currentZoom >= x) {
        if (char.hyperlinkAddress) {
          if (isNaN(parseInt(char.hyperlinkAddress))) {
            window.open(char.hyperlinkAddress, '_blank', `left=50,top=80,width=${window.innerWidth - 100},height=${window.innerHeight - 100}`)
          } else {
            this.isInternalHyperlinkClicked = true
            this.gotoPage(parseInt(char.hyperlinkAddress))
          }
          return true
        }
      }
    }
  }

  private onMouseMove(e: MouseEvent) {
    if (!this.isMouseDown) return
    this.doClick(e, this.caret2)
    this.paintSelection(this.selectColor)

  }

  private onMouseUp(e: MouseEvent) {
    // 只能先暂时这样处理，否则超链接会去到目标页的下一页，必须强行切换至上一页
    if (this.isInternalHyperlinkClicked) {
      this.changePageLast()
    }
    this.isMouseDown = false
    this.isInternalHyperlinkClicked = false
  }

  private doClick(e: MouseEvent, caret: Caret) {
    let x = e.offsetX, y = this.viewMode == ViewMode.SinglePage ? e.offsetY : e.offsetY + this.scrolly
    let page = this.getClickPage(y)
    if (!page) return
    caret.page = page
    let lines = page.lines
    // 通过y来判断所在行，但是有的行是叠在一行的,所以选择后需要再次筛选
    let temp = []
    if (this.viewMode == ViewMode.Contious) y -= page.y * this.zoom * this.currentZoom // 单页的不需要减
    if (this.viewMode == ViewMode.SinglePage) {
      let offy;
      if (this.showComment && !this.checkFull()) {
        offy = (this.viewHeight - this.doc.pagesize.height * this.zoom * this.currentZoom - $('#comment').outerHeight()) / 2
      } else {
        offy = (this.viewHeight - this.doc.pagesize.height * this.zoom * this.currentZoom) / 2
      }
      for (let i = 0; i < lines.length; i++) {
        let line = lines[i]
        if ((line.y + this.calTextHeightOffset(line.height)) * this.zoom * this.currentZoom + offy >= y && (line.y - line.height + this.calTextHeightOffset(line.height)) * this.zoom * this.currentZoom + offy <= y) {
          if (line.x * this.zoom * this.currentZoom < x && (line.x + line.width) * this.zoom * this.currentZoom > x) {
            temp.push({
              line,
              i
            })
          }
        }
      }
    } else {
      for (let i = 0; i < lines.length; i++) {
        let line = lines[i]
        if ((line.y + this.calTextHeightOffset(line.height)) * this.zoom * this.currentZoom >= y && (line.y - line.height + this.calTextHeightOffset(line.height)) * this.zoom * this.currentZoom <= y) {
          if (line.x * this.zoom * this.currentZoom < x && (line.x + line.width) * this.zoom * this.currentZoom > x) {
            temp.push({
              line,
              i
            })
          }
        }
      }
    }

    temp.sort((a, b) => {
      return b.line.x - a.line.x
    })
    if (temp.length > 0) {
      caret.lineIndex = temp[0].i
      this.clickLine(x, y, temp[0].line, caret)
    }
  }

  private getClickPage(y: number): Page {
    let pages = this.doc.pages;
    if (this.viewMode == ViewMode.SinglePage) {
      let pageStart = pages[this.startPageIndex]
      let offy;
      if (this.showComment && !this.checkFull()) {
        offy = (this.viewHeight - this.doc.pagesize.height * this.zoom * this.currentZoom - $('#comment').outerHeight()) / 2
      } else {
        offy = (this.viewHeight - this.doc.pagesize.height * this.zoom * this.currentZoom) / 2
      }
      if (offy <= y && y <= offy + this.doc.pagesize.height * this.zoom * this.currentZoom) {
        return pageStart;
      }
    } else {
      for (let i = this.startPageIndex; i <= this.endPageIndex; i++) {
        let page = pages[i];
        if (page.y * this.zoom * this.currentZoom <= y && (page.y + page.height) * this.zoom * this.currentZoom >= y) {
          return page;
        }
      }
    }
    return null;
  }

  private clickLine(mx, my, line, caret: Caret) {
    caret.line = line
    let chars = line.chars, length = chars.length
    if (mx <= line.x * this.zoom * this.currentZoom) {
      caret.x = line.x
      caret.off = 0
    } else if (mx >= (line.x + line.width) * this.zoom * this.currentZoom) {
      caret.x = line.x + line.width
      caret.off = chars.length
    } else {
      let ch: any, x = line.x, cwidth, fwidth = this.lastCharWidth(line.height)
      for (let j = 0; j < length; j++) {
        ch = chars[j], cwidth = ch.width
        if (cwidth > fwidth) {
          if (x * this.zoom * this.currentZoom <= mx && mx < (x + fwidth / 2) * this.zoom * this.currentZoom) {
            caret.off = j
            caret.x = x
            return
          } else if ((x + fwidth / 2) * this.zoom * this.currentZoom < mx && mx <= (x + fwidth) * this.zoom * this.currentZoom) {
            caret.off = j + 1
            caret.x = x + fwidth
            return
          } else if ((x + fwidth) * this.zoom * this.currentZoom < mx && mx <= (x + cwidth) * this.zoom * this.currentZoom) {
            caret.off = j + 1
            caret.x = x + cwidth
            return
          }
        } else {
          if (x * this.zoom * this.currentZoom <= mx && mx < (x + cwidth / 2) * this.zoom * this.currentZoom) {
            caret.off = j
            caret.x = x
            return
          } else if ((x + cwidth / 2) * this.zoom * this.currentZoom < mx && mx <= (x + cwidth) * this.zoom * this.currentZoom) {
            caret.off = j + 1
            caret.x = x + cwidth
            return
          }
        }

        x += cwidth
      }
    }
  }

  private paintCaret() {
    if (!this.isPaintSelect) return
    let caret = this.caret1
    let g = this.maskg
    g.clearRect(0, 0, this.canvasWidth / this.currentZoom, this.canvasHeight / this.currentZoom)
    if (!caret.line) return
    let page = caret.page
    if (this.viewMode == ViewMode.SinglePage) {
      let offy;
      if (this.showComment && !this.checkFull()) {
        offy = (this.viewHeight - this.doc.pagesize.height * this.zoom * this.currentZoom - $('#comment').outerHeight()) / 2
      } else {
        offy = (this.viewHeight - this.doc.pagesize.height * this.zoom * this.currentZoom) / 2
      }
      g.translate(page.x * this.zoom, 0)
      g.fillStyle = 'rgb(0,0,0)'
      g.lineWidth = 1
      g.fillRect(caret.x * this.zoom, (caret.line.y - caret.line.height + this.calTextHeightOffset(caret.line.height)) * this.zoom + offy / this.currentZoom, 1, caret.line.height * this.zoom)
      g.translate(-page.x * this.zoom, 0)
    } else {
      let scrolly = this.scrolly / this.currentZoom
      g.translate(page.x * this.zoom, (page.y * this.zoom - scrolly))
      g.fillStyle = 'rgb(0,0,0)'
      g.lineWidth = 1
      g.fillRect(caret.x * this.zoom, (caret.line.y - caret.line.height + this.calTextHeightOffset(caret.line.height)) * this.zoom, 1, caret.line.height * this.zoom)
      g.translate(-page.x * this.zoom, (-page.y * this.zoom + scrolly))
    }
  }

  paintSelection(color: string) {
    if (!this.isPaintSelect) return
    let c1 = this.caret1, c2 = this.caret2, g = this.maskg
    let offy;
    if (this.showComment && !this.checkFull()) {
      offy = (this.viewHeight - this.doc.pagesize.height * this.zoom * this.currentZoom - $('#comment').outerHeight()) / 2
    } else {
      offy = (this.viewHeight - this.doc.pagesize.height * this.zoom * this.currentZoom) / 2
    }
    g.clearRect(0, 0, this.canvasWidth / this.currentZoom, this.canvasHeight / this.currentZoom)
    if (!c1.line) return
    let page = c1.page
    let scrolly = this.scrolly / this.currentZoom
    let diffValue = 5 // 解决艺术字重叠的问题设置的极差值
    if (this.viewMode == ViewMode.SinglePage) {
      g.translate(page.x * this.zoom, 0)
      let startx = c1.x, startLine = c1.line, endx = c2.x, endLine = c2.line
      let startLineIndex = c1.lineIndex, endLineIndex = c2.lineIndex
      if (c1.line.y > c2.line.y) {
        startx = c2.x, startLine = c2.line, endx = c1.x, endLine = c1.line
        startLineIndex = c2.lineIndex, endLineIndex = c1.lineIndex
      }
      g.globalAlpha = 0.3
      g.fillStyle = color// '#357EC7'
      if (c1.line === c2.line) {
        // 表格内单行选取
        if (startLine.type === -1) {
          let zoom = this.zoom
          startLine.phrases.map((v: any) => {
            v.r = v.x + v.width
            if (startx <= v.x && v.x <= endx && startx <= v.r && v.r <= endx) {
              g.fillRect(v.x * zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom + offy / this.currentZoom, v.width * zoom, startLine.height * zoom)

            } else if (startx >= v.x && v.x <= endx && startx <= v.r && v.r <= endx) {
              g.fillRect(startx * zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom + offy / this.currentZoom, (v.r - startx) * zoom, startLine.height * zoom)

            } else if (startx <= v.x && v.x <= endx && startx <= v.r && v.r >= endx) {
              g.fillRect(v.x * zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom + offy / this.currentZoom, (endx - v.x) * zoom, startLine.height * zoom)

            } else if (startx >= v.x && v.x <= endx && startx <= v.r && v.r >= endx) {
              g.fillRect(startx * zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom + offy / this.currentZoom, (endx - startx) * zoom, startLine.height * zoom)

            }
          })
        } else {
          g.fillRect(startx * this.zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom + offy / this.currentZoom, (endx - startx) * this.zoom, startLine.height * this.zoom)
        }

      } else if (endLine.y - startLine.y < startLine.height / 2) {
        g.fillRect(startx * this.zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom + offy / this.currentZoom, (endx - startx) * this.zoom, startLine.height * this.zoom)

      } else {
        let lines = page.lines
        // 选取第一行
        if (startLine.type === -1) {
          let zoom = this.zoom
          startLine.phrases.map((v: any) => {
            v.r = v.x + v.width || 0
            // 露头
            if (startx >= v.x && startx <= v.r) {
              g.fillRect(startx * zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom + offy / this.currentZoom, (v.r - startx) * zoom, startLine.height * zoom)

            } else if (v.x >= startx) {
              g.fillRect(v.x * zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom + offy / this.currentZoom, v.width * zoom, startLine.height * zoom)
            }
          })
        } else {
          g.fillRect(startx * this.zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom + offy / this.currentZoom, (startLine.x + startLine.width - startx) * this.zoom, startLine.height * this.zoom)
        }
        // 选取中间行
        for (let i = startLineIndex + 1; i < endLineIndex; i++) {
          let line = lines[i]
          let nextLine = lines[i + 1]
          let zoom = this.zoom
          // 解决艺术字重叠的问题
          if (Math.abs(line.x - lines[i - 1].x) < diffValue && Math.abs(line.y - lines[i - 1].y) < diffValue) continue
          if (line.type === -1) {
            line.phrases.map((v: any) => {
              v.r = v.x + v.width
              g.fillRect(v.x * zoom, (line.y - line.height + this.calTextHeightOffset(line.height)) * this.zoom + offy / this.currentZoom, v.width * zoom, line.height * zoom)

            })
          } else {
            // 有重叠
            if (nextLine.y - line.y < line.height / 2) {
              // 且重叠行为最后一行
              if (i + 1 === endLineIndex) {
                g.fillRect(line.x * zoom, (line.y - line.height + this.calTextHeightOffset(line.height)) * this.zoom + offy / this.currentZoom, (endx - line.x) * zoom, line.height * zoom)

              } else {
                g.fillRect(line.x * zoom, (line.y - line.height + this.calTextHeightOffset(line.height)) * this.zoom + offy / this.currentZoom, (nextLine.x - line.x) * zoom, line.height * zoom)

              }
            } else {
              g.fillRect(line.x * zoom, (line.y - line.height + this.calTextHeightOffset(line.height)) * this.zoom + offy / this.currentZoom, line.width * zoom, line.height * zoom)

            }
          }

        }
        // 选取末行
        if (Math.abs(lines[endLineIndex - 1].x - lines[endLineIndex].x) >= diffValue || Math.abs(lines[startLineIndex].y - lines[endLineIndex].y) >= diffValue) {
          let zoom = this.zoom
          if (endLine.type === -1) {
            endLine.phrases.map((v: any) => {
              v.r = v.x + v.width
              if (v.x <= endx && v.r >= endx) {
                g.fillRect(v.x * zoom, (endLine.y - endLine.height + this.calTextHeightOffset(endLine.height)) * zoom + offy / this.currentZoom, (endx - v.x) * zoom, endLine.height * zoom)

              } else if (v.r <= endx) {
                g.fillRect(v.x * zoom, (endLine.y - endLine.height + this.calTextHeightOffset(endLine.height)) * zoom + offy / this.currentZoom, v.width * zoom, endLine.height * zoom)

              }
            })
          } else {
            let proLine = lines[endLineIndex - 1]
            if (endLine.y - proLine.y > endLine.height / 2) {
              g.fillRect(endLine.x * zoom, (endLine.y - endLine.height + this.calTextHeightOffset(endLine.height)) * zoom + offy / this.currentZoom, (endx - endLine.x) * zoom, endLine.height * zoom)
            }
          }

        }
      }
      g.globalAlpha = 1
      g.translate(-page.x * this.zoom, 0)
    } else {
      g.translate(page.x * this.zoom, (page.y * this.zoom - scrolly))
      let startx = c1.x, startLine = c1.line, endx = c2.x, endLine = c2.line
      let startLineIndex = c1.lineIndex, endLineIndex = c2.lineIndex
      if (c1.line.y > c2.line.y) {
        startx = c2.x, startLine = c2.line, endx = c1.x, endLine = c1.line
        startLineIndex = c2.lineIndex, endLineIndex = c1.lineIndex
      }
      g.globalAlpha = 0.3
      g.fillStyle = color// '#357EC7'
      if (c1.line === c2.line) {
        // 表格内单行选取
        if (startLine.type === -1) {
          let zoom = this.zoom
          startLine.phrases.map((v: any) => {
            v.r = v.x + v.width
            if (startx <= v.x && v.x <= endx && startx <= v.r && v.r <= endx) {
              g.fillRect(v.x * zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom, v.width * zoom, startLine.height * zoom)

            } else if (startx >= v.x && v.x <= endx && startx <= v.r && v.r <= endx) {
              g.fillRect(startx, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * zoom, v.r * zoom - startx, startLine.height * zoom)

            } else if (startx <= v.x && v.x <= endx && startx <= v.r && v.r >= endx) {
              g.fillRect(v.x * zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * zoom, (endx - v.x) * zoom, startLine.height * zoom)

            } else if (startx >= v.x && v.x <= endx && startx <= v.r && v.r >= endx) {
              g.fillRect(startx * zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * zoom, (endx - startx) * zoom, startLine.height * zoom)

            }
          })
        } else {
          g.fillRect(startx * this.zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom, (endx - startx) * this.zoom, startLine.height * this.zoom)
        }
      } else if (endLine.y - startLine.y < startLine.height / 2) {
        g.fillRect(startx * this.zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom, (endx - startx) * this.zoom, startLine.height * this.zoom)

      } else {
        let lines = page.lines

        // 选取第一行
        if (startLine.type === -1) {
          let zoom = this.zoom
          startLine.phrases.map((v: any) => {
            v.r = v.x + v.width
            // 露头
            if (startx >= v.x && startx <= v.r) {
              g.fillRect(startx * zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom, (v.r - startx) * zoom, startLine.height * zoom)

            } else if (v.x >= startx) {
              g.fillRect(v.x * zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom, v.width * zoom, startLine.height * zoom)
            }
          })
        } else {
          g.fillRect(startx * this.zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom, (startLine.x + startLine.width - startx) * this.zoom, startLine.height * this.zoom)
        }
        // 选取中间行
        for (let i = startLineIndex + 1; i < endLineIndex; i++) {
          let line = lines[i]
          let nextLine = lines[i + 1]
          let zoom = this.zoom
          // 解决艺术字重叠的问题
          if (Math.abs(line.x - lines[i - 1].x) < diffValue && Math.abs(line.y - lines[i - 1].y) < diffValue) continue
          if (line.type === -1) {
            line.phrases.map((v: any) => {
              v.r = v.x + v.width
              g.fillRect(v.x * zoom, (line.y - line.height + this.calTextHeightOffset(line.height)) * this.zoom, v.width * zoom, line.height * zoom)

            })
          } else {
            // 有重叠
            if (nextLine.y - line.y < line.height / 2) {
              // 且重叠行为最后一行
              if (i + 1 === endLineIndex) {
                g.fillRect(line.x * zoom, (line.y - line.height + this.calTextHeightOffset(line.height)) * this.zoom, (endx - line.x) * zoom, line.height * zoom)

              } else {
                g.fillRect(line.x * zoom, (line.y - line.height + this.calTextHeightOffset(line.height)) * this.zoom, (nextLine.x - line.x) * zoom, line.height * zoom)

              }
            } else {
              g.fillRect(line.x * zoom, (line.y - line.height + this.calTextHeightOffset(line.height)) * this.zoom, line.width * zoom, line.height * zoom)

            }
          }

        }
        // 选取末行
        if (Math.abs(lines[endLineIndex - 1].x - lines[endLineIndex].x) >= diffValue || Math.abs(lines[startLineIndex].y - lines[endLineIndex].y) >= diffValue) {
          let zoom = this.zoom
          if (endLine.type === -1) {
            endLine.phrases.map((v: any) => {
              v.r = v.x + v.width
              if (v.x < endx && v.r > endx) {
                g.fillRect(v.x * this.zoom, (endLine.y - endLine.height + this.calTextHeightOffset(endLine.height)) * this.zoom, (endx - v.x) * this.zoom, endLine.height * this.zoom)

              } else if (v.r < endx) {
                g.fillRect(v.x * this.zoom, (endLine.y - endLine.height + this.calTextHeightOffset(endLine.height)) * this.zoom, v.width * this.zoom, endLine.height * this.zoom)

              }
            })
          } else {
            let proLine = lines[endLineIndex - 1]
            if (endLine.y - proLine.y > endLine.height / 2) {
              g.fillRect(endLine.x * this.zoom, (endLine.y - endLine.height + this.calTextHeightOffset(endLine.height)) * this.zoom, (endx - endLine.x) * this.zoom, endLine.height * this.zoom)
            }
          }

        }
      }
      g.globalAlpha = 1
      g.translate(-page.x * this.zoom, (-page.y * this.zoom + scrolly))
    }
  }

  private calTextHeightOffset(height: number): number {
    return Math.round(height / 10) * 2
  }

  // 获取选中的文字内容
  private copyContent() {
    let c1 = this.caret1, c2 = this.caret2
    if (!c1.page) return
    if (!this.hasSelection()) return

    let startLine = c1.line, startoff = c1.off, endLine = c2.line, endoff = c2.off
    let startLineIndex = c1.lineIndex, endLineIndex = c2.lineIndex
    if (c1.line.y > c2.line.y) {
      startLine = c2.line, startoff = c2.off, endLine = c1.line, endoff = c1.off
      startLineIndex = c2.lineIndex, endLineIndex = c1.lineIndex
    }
    if (c1.line == c2.line && c1.x > c2.x) {
      c1 = this.caret2, c2 = this.caret1
      startLine = c1.line, startoff = c1.off, endLine = c2.line, endoff = c2.off
      startLineIndex = c1.lineIndex, endLineIndex = c2.lineIndex
    }
    let t = ''
    if (c1.line === c2.line) {
      t = this.getLineText(startLine, startoff, endoff)
    } else {
      let lines = c1.page.lines
      t += this.getLineText(startLine, startoff, -1) + '\n'
      for (let i = startLineIndex + 1; i < endLineIndex; i++) {
        t += this.getLineText(lines[i], 0, -1) + '\n'
      }
      t += this.getLineText(endLine, 0, endoff)
    }
    return t
  }

  // 移动端选取
  private MobileMousedown(event) {
    this.isMouseDown = true
    this.caret1 = Object.create(null)
    this.caret2 = Object.create(null)
    this.MobileDoClick(event, this.caret1)
    // 根据caret1位置生成初始的caret2的位置
    if (!this.caret1.line) return
    this.caret2.line = this.caret1.line
    this.caret2.lineIndex = this.caret1.lineIndex
    this.caret2.page = this.caret1.page
    if (this.caret1.off === this.caret1.line.chars.length) {
      this.caret2.off = this.caret1.off
      this.caret2.x = this.caret1.x
      this.caret1.off = this.caret1.off - 1
      this.caret1.x = this.caret1.line.chars[this.caret1.off].x
    } else {
      this.caret2.off = this.caret1.off + 1
      this.caret2.x = this.caret1.line.chars[this.caret1.off].x + this.caret1.line.chars[this.caret1.off].width
    }

    if (document.getElementById('copyInput')) document.getElementById('copyInput').remove() // 删除复制按钮
    let copyInput = document.createElement('input')
    copyInput.id = 'copyInput'
    copyInput.type = 'button'
    copyInput.value = '复  制'
    copyInput.onclick = (e) => {
      this.onCopy()
      this.removeMobileCeret()
    }
    document.body.appendChild(copyInput);
    this.MobilePaintSelection('#357EC7')
  }

  private removeMobileCeret() {
    this.caret1 = Object.create(null)
    this.caret2 = Object.create(null)
    if (document.getElementById('copyInput')) document.getElementById('copyInput').remove() // 删除复制按钮
    this.MobilePaintSelection('#357EC7')
  }

  private MoibleJudgeMove(e) {
    let x = e.offsetX
    let y = e.offsetY
    let rangeSizeVal = 6
    // 判断移动的是否移动的是caret1
    if (this.caret1.line) {
      // 设置选取的便宜范围，根据caret的heght设置范围
      let offsetRange = this.calTextHeightOffset(this.caret1.line.height) * rangeSizeVal
      let caretX = (this.caret1.x + this.caret1.page.x) * this.zoom * this.currentZoom
      let caretY = (this.caret1.line.y + this.caret1.page.y + this.calTextHeightOffset(this.caret1.line.height) - this.caret1.line.height) * this.zoom * this.currentZoom - this.scrolly
      if ((x >= caretX - offsetRange && x <= caretX + offsetRange) && (y >= caretY - offsetRange && y <= caretY + offsetRange * 1.5)) {
        // 当触点在这个范围内，就可以拖动选取的区域了,更新caret1的值，重新绘制选取区域
        return 1
      }
    }
    // 判断移动的是否移动的是caret2
    if (this.caret2.line) {
      // 设置选取的便宜范围，根据caret的heght设置范围
      let offsetRange = this.calTextHeightOffset(this.caret2.line.height) * rangeSizeVal
      let caretX = (this.caret2.x + this.caret2.page.x) * this.zoom * this.currentZoom
      let caretY = (this.caret2.line.y + this.caret2.page.y + this.calTextHeightOffset(this.caret2.line.height)) * this.zoom * this.currentZoom - this.scrolly
      if ((x >= caretX - offsetRange && x <= caretX + offsetRange) && (y >= caretY - offsetRange && y <= caretY + offsetRange * 1.5)) {
        // 当触点在这   个范围内，就可以拖动选取的区域了,更新caret1的值，重新绘制选取区域
        return 2
      }
    }
    return 0
  }

  private MobileDoClick(e, caret: Caret) {
    if (!e) return
    let devation = 10 // 发现选取会右偏，暂时设置个偏移量
    let x = e.offsetX - devation, y = e.pageY + this.scrolly
    let page = this.getClickPage(y)
    if (!page) return
    caret.page = page
    let lines = page.lines
    y -= page.y * this.zoom * this.currentZoom
    for (let i = 0; i < lines.length; i++) {
      let line = lines[i]
      if ((line.y + this.calTextHeightOffset(line.height)) * this.zoom * this.currentZoom >= y && (line.y - line.height + this.calTextHeightOffset(line.height)) * this.zoom * this.currentZoom <= y) {
        caret.lineIndex = i
        this.clickLine(x, y, line, caret)
        return
      }
    }
  }

  private MobilePaintCaret(model, g, startx, starty, width, height, color?: string) { // 绘制复制的选取两侧的图形
    let r = height * 0.4
    // 绘制整个选中区域
    g.globalAlpha = 0.3
    g.fillStyle = color || '#357EC7'// '#357EC7'
    g.strokeStyle = color || '#357EC7'
    g.fillRect(startx, starty, width, height)
    g.globalAlpha = 0.7
    // g.fillStyle = 'rgb(0,0,0)'
    g.lineWidth = 1
    // 绘制选中区域左侧边
    if (model === 1 || model === 3) g.fillRect(startx, starty, -1, height)
    // 绘制选中区域右侧边
    if (model === 2 || model === 3) g.fillRect(startx + width, starty, 1, height)
    // 绘制左上角圆圈
    if (model === 1 || model === 3) {
      g.beginPath()
      g.arc(startx, starty - r / 2, r / 2, 0.5 * Math.PI, -1.5 * Math.PI)
      g.lineTo(startx, starty + height)
      g.stroke()
      g.fill()
    }
    // 绘制右下角圆圈
    if (model === 2 || model === 3) {
      g.beginPath()
      g.lineTo(startx + width, starty)
      g.arc(startx + width, starty + height + r / 2, r / 2, 1.5 * Math.PI, -0.5 * Math.PI)
      g.stroke()
      g.fill()
    }
  }

  private MobilePaintSelection(color?: string) {
    let c1 = this.caret1, c2 = this.caret2, g = this.maskg
    g.clearRect(0, 0, this.canvasWidth / this.currentZoom, this.canvasHeight / this.currentZoom) //放置清除区域与需要的清除区域不同导致有的地方重复绘制
    if (!c1.line || !c2.line) return
    let page = c1.page
    let scrolly = this.scrolly / this.currentZoom
    g.translate(page.x * this.zoom, (page.y * this.zoom - scrolly))
    let startx = c1.x, startLine = c1.line, startPage = c1.page, endx = c2.x, endLine = c2.line, endPage = c2.page
    let startLineIndex = c1.lineIndex, endLineIndex = c2.lineIndex
    if (c1.line.y > c2.line.y) {
      startx = c2.x, startLine = c2.line, startPage = c2.page, endx = c1.x, endLine = c1.line, endPage = c1.page
      startLineIndex = c2.lineIndex, endLineIndex = c1.lineIndex
    } else {
      if (c1.line.y == c2.line.y && c1.x > c2.x) {
        startx = c2.x, endx = c1.x
      }
    }
    // 更新复制按钮的位置
    let copyInput = document.getElementById('copyInput')
    if (copyInput) {
      copyInput.style.top = (endLine.y + endPage.y - endLine.height) * this.zoom * this.currentZoom - 22 - this.scrolly + 'px'
      copyInput.style.left = endx * this.zoom * this.currentZoom - $('#dcs-pgreader-canvaswrapper').scrollLeft() - 50 + 'px'
    }
    // 画的时候传入参数，是否需要画两侧的拖拽跳 0：两侧都不需要 1：左侧需要 2：右侧需要 3：两侧都需要
    if (c1.line === c2.line) {
      this.MobilePaintCaret(3, g, startx * this.zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom, (endx - startx) * this.zoom, startLine.height * this.zoom, color)
    } else {
      let lines = page.lines
      this.MobilePaintCaret(1, g, startx * this.zoom, (startLine.y - startLine.height + this.calTextHeightOffset(startLine.height)) * this.zoom, (startLine.x + startLine.width - startx) * this.zoom, startLine.height * this.zoom, color)
      for (let i = startLineIndex + 1; i < endLineIndex; i++) {
        let line = lines[i]
        this.MobilePaintCaret(0, g, line.x * this.zoom, (line.y - line.height + this.calTextHeightOffset(line.height)) * this.zoom, line.width * this.zoom, line.height * this.zoom, color)
      }
      this.MobilePaintCaret(2, g, endLine.x * this.zoom, (endLine.y - endLine.height + this.calTextHeightOffset(endLine.height)) * this.zoom, (endx - endLine.x) * this.zoom, endLine.height * this.zoom, color)
    }
    g.globalAlpha = 1
    g.translate(-page.x * this.zoom, (-page.y * this.zoom + scrolly))
  }

  public onCopy() {
    let text = this.copyContent()
    let jqMenu = document.getElementById('copyInput')
    if (text) copyTextToClipboard(text)
    function fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      console.log(text)
      textArea.style.position = 'absolute';
      if (jqMenu) {
        textArea.style.top = jqMenu.style.top;
        textArea.style.left = jqMenu.style.left;
      } else {
        textArea.style.top = '0px';
        textArea.style.left = '0px';
      }
      textArea.style.opacity = '0';
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }
      document.body.removeChild(textArea);
    }
    function copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(
        function () {
          console.log("Async: Copying to clipboard was successful!");
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
    }
  }

  private getLineText(line: any, start, end) {
    let chars = line.chars
    if (end == -1) end = chars.length
    let t = ''
    for (let i = start; i < end; i++) {
      t += chars[i].t
    }
    return t
  }

  public hasSelection() {
    let c1 = this.caret1, c2 = this.caret2
    return c1.page && c2.page && c1.line && c2.line && ((c1.line === c2.line && c1.off != c2.off) || (c1.line !== c2.line))
  }

  /**
   * 根据最后一个字符的高度来算出最后一个字符的宽度
   * @param lastCharHeight 
   */
  private lastCharWidth(lastCharHeight: number) {
    return lastCharHeight - Math.round(lastCharHeight / 10) * 1
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////// 
  /////////////////////////////////选取复制 end/////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////// 

  /////////////////////////////////////////////////////////////////////////////////////////////////// 
  /////////////////////////////////PRINT START/////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////// 
  //print pages in range[from,end]
  private isPrinting: boolean
  private printingStartIndex: number
  private printingEndIndex: number
  private currentPrintingIndex: number
  private onPrintPagesComplete: any
  private printCanvas: HTMLCanvasElement  //the offscreen canvas used for print only
  async printPages(printContainer: HTMLDivElement, start, end, onPrintPagesComplete) {
    this.isPrinting = true
    this.onPrintPagesComplete = onPrintPagesComplete
    let pages = this.doc.pages, page: Page
    if (end == -1) end = pages.length - 1
    let printCanvas = this.printCanvas
    if (!printCanvas) {
      printCanvas = document.createElement('canvas')
    }
    for (let i = start; i <= end; i++) {
      page = pages[i]
      if (page.state != LoadState.Ready) {
        let resp = await axios.get(this.pageUrlRoot + page.index + '.json' + this.suffixUrl, { responseType: 'json' })
        Object.assign(page, resp.data)
        page.state = LoadState.Ready
        await this.forceLoadPageResourceForPrint(page)
      }
    }

    this.currentPrintingIndex = start
    this.printingStartIndex = start
    this.printingEndIndex = end;

    this.printNext(printCanvas, printContainer)
  }
  private doPrintPage(printCanvas: HTMLCanvasElement, page: Page, printContainer: HTMLDivElement, isFirst: boolean) {
    Util.resizeCanvas(printCanvas, page.width, page.height, 2)
    let g = printCanvas.getContext('2d')
    g.setTransform(2, 0, 0, 2, 0, 0)
    g.clearRect(0, 0, printCanvas.width, printCanvas.height)
    g.fillStyle = 'white'
    g.fillRect(0, 0, page.width, page.height)
    this.paintPage(g, page)

    //create printpage
    let div = document.createElement('div')
    div.style.margin = '0 auto'
    //div.style.border='1px solid black'
    div.style.marginBottom = '20px'
    div.style.width = (page.width * Common.CSSUnit) + 'px'
    div.style.height = (page.height * Common.CSSUnit) + 'px'
    if (!isFirst) {
      div.className = 'pagebreak'
    }
    let img = new Image()
    img.width = (page.width * Common.CSSUnit)
    img.height = (page.height * Common.CSSUnit)
    img.onload = () => {
      requestAnimationFrame(() => this.printNext(printCanvas, printContainer))
    }
    img.src = printCanvas.toDataURL() + this.suffixUrl
    div.appendChild(img)
    printContainer.appendChild(div)
  }
  private printNext(printCanvas: HTMLCanvasElement, printContainer: HTMLDivElement) {
    if (this.currentPrintingIndex <= this.printingEndIndex) {
      let isFirst = this.currentPrintingIndex == this.printingStartIndex;
      let page = this.doc.pages[this.currentPrintingIndex]
      this.currentPrintingIndex++
      this.doPrintPage(printCanvas, page, printContainer, isFirst)
    } else {
      this.isPrinting = false
      if (this.onPrintPagesComplete) this.onPrintPagesComplete()
    }
  }

  async forceLoadPageResourceForPrint(page: Page) {
    let all = []
    for (let layer of page.layers) {
      for (let obj of layer) {
        if ((obj as any).ref) {
          obj = this.doc.refById[(obj as any).ref]
          if (!obj) continue
        }
        switch (obj.t) {
          case ObjType.Image:
            let imageObj = obj as ImageObj
            if (imageObj.state != LoadState.Ready) {
              imageObj.state = LoadState.Loading
              let imageData = imageObj.data = Object.create(null) as RemoteImageData
              imageData.path = obj.v

              await new Promise((resolve) => {
                let img = imageData.img = new Image()
                img.onload = () => {
                  imageData.state = LoadState.Ready
                  resolve(null)
                }
                img.onerror = resolve
                img.src = this.pageUrlRoot + imageData.path + this.suffixUrl
              })
              imageObj.state = LoadState.Ready
            }
            break
          case ObjType.Path:
            let pathObj = obj as PathObj
            if (pathObj.type === 4) {
              let loading = this.loadingImages
              if (!loading[pathObj.paintInfo]) {
                all.push(new Promise((resolve) => {
                  this.loadPathImage(pathObj, resolve);
                }))
              }
            }
            break
        }
      }
    }
    await Promise.all(all)
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////// 
  /////////////////////////////////PRINT END/////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////// 

  //控制是否隐藏sidebar
  private isHide: boolean = true
  public isHideSidebar(isSetFull?: boolean) {
    let pgLeftpanel = document.getElementById('pg-leftpanel');
    let isElementHidden = this.isElementHidden(pgLeftpanel)
    if (this.isHide && !isElementHidden) {
      this.isHide = false;
      pgLeftpanel.style.display = 'none';
      if (!isSetFull) this.resizeWindow(this.currentZoom);
    } else {
      this.isHide = true;
      pgLeftpanel.style.display = 'inline-block';
      if (!isSetFull) this.resizeWindow(this.currentZoom);
    }
  }

  /**
   * 更新pagecount的数量,更新sidebar的选定框
   */
  private resizeSidebar(): void {
    if (this.doc.pages.length <= 0) return;
    //更新pagecount的数量
    let totalPage = document.getElementById('totalPage');
    totalPage.innerText = this.doc.pages.length + '';
    document.getElementById('allpage').innerText = this.doc.pages.length + '';
    //更新首页sidebar的选定框
    $('#pg-leftpanel div:first').addClass('totalPagePoint')
  }

  public changePage(index: number): void {
    let pageIndex = Number(index);
    this.gotoPage(pageIndex - 1);
  }

  public changePageLast() {
    console.log('last')
    let pageIndex = Number(document.getElementById('activePage').getAttribute('value'));
    if (pageIndex === 1) return
    this.gotoPage(pageIndex - 2);
  }

  public changePageNext() {
    console.log('next')
    let pageIndex = Number(document.getElementById('activePage').getAttribute('value'));
    if (pageIndex === this.doc.pages.length) return
    this.gotoPage(pageIndex);
  }

  /**
   * 输入的input框里面回车跳转指定内容
   */
  public keyDownChangePage(e, index) {
    var keynum = window.event ? e.keyCode : e.which;
    if (keynum == 13) {
      this.changePage(index)
    }
  }

  private changeInputPage(index: number): void {
    // if (this.isMobile) return
    index = Number(index)
    // 当输入在页码框中输入错误页码后点击文档区域页码不会还原或有错误提示
    if (index < 0 || index > this.doc.pages.length - 1) {
      $('#activePage').css({
        'border': '1px solid red',
        'border-radius': '5px'
      });
      $('#activePage').attr({
        title: '输入的页码超出文档范围'
      });
      return;
    } else {
      $('#activePage').css({
        'border': 'none',
        'border-radius': '0px'
      })
      $('#activePage').removeAttr('title');
      // 当pageindex是首页的时候，上一页和|需要显示为灰色，且不能被点击
      if (index === 0) {
        $('#changePageLast').addClass('lightgrey unclick')
        $('#changePageLast img').attr('src', './wp/lastPageGrey.svg')
        $('#separator').addClass('lightgrey')
        if (!this.fullscreenState) {
          $('#leftBtn').addClass('hiden')
        }

      } else {
        $('#changePageLast').removeClass('lightgrey unclick')
        $('#changePageLast img').attr('src', './wp/lastPage.svg')
        $('#separator').removeClass('lightgrey')
        if (!this.fullscreenState) {
          $('#leftBtn').removeClass('hiden')
        }
      }
      // 当pageindex是最后一页的时候，下一页和|需要显示为灰色，且不能被点击
      if (index === this.doc.pages.length - 1) {
        $('#changePageNext').addClass('lightgrey unclick')
        $('#changePageNext img').attr('src', './wp/nextPageGrey.svg')
        $('#separator').addClass('lightgrey')
        if (!this.fullscreenState) {
          $('#rightBtn').addClass('hiden')
        }

      } else {
        $('#changePageNext').removeClass('lightgrey unclick')
        $('#changePageNext img').attr('src', './wp/nextPage.svg')
        $('#separator').removeClass('lightgrey')
        if (!this.fullscreenState) {
          $('#rightBtn').removeClass('hiden')
        }
      }
    };
    let pageIndex = Number(index);
    // 更新sidebar中选中框的颜色
    if (!this.isMobile) {
      let leftpanels = document.getElementById('pg-leftpanel').getElementsByTagName('div');
      for (let i = 0; i < leftpanels.length; i++) {
        $('#pg-leftpanel div:eq(' + i + ')').removeClass('totalPagePoint')
      }
      $('#pg-leftpanel div:eq(' + pageIndex + ')').addClass('totalPagePoint')
    }

    // 更新输入框中的跳转页数
    let inputValue: string = document.getElementById('activePage').getAttribute('value');
    $('#nowpage').text(pageIndex + 1);
    if ((pageIndex + 1) !== Number(inputValue)) {
      document.getElementById('activePage')['value'] = (pageIndex + 1) + '';
      document.getElementById('activePage').setAttribute('value', (pageIndex + 1) + '');
    }
  }

  //zoom
  private scale_text: HTMLElement
  private currentZoom: number
  private maxZoom: number = 2
  private minZoom: number = 0.2
  private adjustZoom: number = 0.1
  private clickZoom: number

  public changeTab(scale: number, mobileZoom?: number) {
    let currentZoom = Math.round(this.currentZoom * 10) / 10
    if (currentZoom > this.minZoom && currentZoom < this.maxZoom) {
      if (scale == 0) {
        currentZoom -= this.adjustZoom
      } else if (scale == 1) {
        currentZoom += this.adjustZoom
      }
    } else if (currentZoom >= this.maxZoom) {
      if (scale == 0) {
        currentZoom -= this.adjustZoom
      } else if (scale == 1) {
        currentZoom = this.maxZoom
      }
    } else if (currentZoom <= this.minZoom) {
      if (scale == 0) {
        currentZoom = this.minZoom
      } else if (scale == 1) {
        currentZoom += this.adjustZoom
      }
    }
    if (!this.isMobile) {
      // 当放大的时候，判断高度和宽度是否超过屏幕区域，超过了就不缩放
      if (this.doc.pagesize.height * this.zoom * currentZoom > this.canvasHeight) {
        if (scale === 1) return
      }
      if (this.doc.pagesize.width * this.zoom * currentZoom > this.showWidth) {
        if (scale === 1) return
      }
      this.scale_text.innerText = Math.round(currentZoom * 100) + '%'
      this.currentZoom = currentZoom
    } else {
      this.currentZoom = mobileZoom
    }
    this.resizeWindow(this.currentZoom)
  }

  public SwiperMobleScroll(e, timer?) {
    if (!e) return;
    if (this.isHideScroller) return // 没有滚动条的时候不需要移动
    let deltaY = -e / this.zoom
    let scrolly = this.scrolly, viewHeight = this.viewHeight, docHeight = this.doc.docHeight * this.zoom * this.currentZoom
    scrolly += deltaY * this.zoom;
    if (scrolly < 0) scrolly = 0
    if (scrolly + viewHeight >= docHeight) {
      scrolly = docHeight - viewHeight
      $('#nowpage').text(this.endPageIndex + 1);
    }
    if (scrolly !== this.scrolly) {
      this.scrolly = scrolly
      this.determineVisiblePages()
      this.changeInputPage(this.startPageIndex) // 实时更新当前page在input框里面的值
      this.disableScrollEvent = true
      this.scroller.scrollTop = scrolly / docHeight * this.scroller.scrollHeight
      if (scrolly > docHeight - viewHeight - 1000 || scrolly < 1000) {
        $('.load8').css({ 'display': 'none' })
        requestAnimationFrame(() => this.paint())
      } else {
        if (timer && Math.abs(e) > 50) {
          $('.load8').css({ 'display': 'block' })
          requestAnimationFrame(() => this.paint(true))
        } else {
          $('.load8').css({ 'display': 'none' })
          requestAnimationFrame(() => this.paint())
        }
      }
    }
  }

  /**
   * 判断是否是移动端
   */
  private isMobile: boolean = false
  private isPhone() {
    let sUserAgent = navigator.userAgent.toLowerCase();
    let bIsIpad = sUserAgent.match(/ipad/i);
    let bIsIphoneOs = sUserAgent.match(/iphone os/i);
    let bIsMidp = sUserAgent.match(/midp/i);
    let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i);
    let bIsUc = sUserAgent.match(/ucweb/i);
    let bIsAndroid = sUserAgent.match(/android/i);
    let bIsCE = sUserAgent.match(/windows ce/i);
    let bIsWM = sUserAgent.match(/windows mobile/i);
    let bIsMac = sUserAgent.match(/macintosh/i);
    if ((bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || bIsMac)) {
      this.isMobile = true;
    }
    if (bIsIphoneOs || bIsIpad) {
      this.isIp = true
    }
  }

  /**
   * if IE below
   */
  private JudgmentBrowser() {
    let userAgent = navigator.userAgent //取得浏览器的userAgent字符串  
    let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1
    let browser = {
      versions: function () {
        let u = navigator.userAgent
        return {
          trident: u.indexOf('Trident') > -1, //IE内核
        }
      }()
    }
    if (browser.versions.trident && !isIE11) return true
  }

  /**
   * if IE Browser
   */
  private JudgmentIEBrowser() {
    let browser = {
      versions: function () {
        let u = navigator.userAgent
        return {
          trident: u.indexOf('Trident') > -1, //IE内核
        }
      }()
    }
    if (browser.versions.trident) return true
  }


  private mobleScroll(e) {
    let deltaY = -e.overallVelocityY * 40
    let scrolly = this.scrolly, viewHeight = this.viewHeight, docHeight = this.doc.docHeight * this.zoom
    scrolly += deltaY * this.zoom;
    if (scrolly < 0) scrolly = 0
    if (scrolly + viewHeight > docHeight) {
      scrolly = docHeight - viewHeight
    }
    if (scrolly !== this.scrolly) {
      this.scrolly = scrolly
      this.determineVisiblePages()
      this.changeInputPage(this.startPageIndex) // 实时更新当前page在input框里面的值
      this.disableScrollEvent = true
      this.scroller.scrollTop = scrolly / docHeight * this.scroller.scrollHeight
      requestAnimationFrame(() => this.paint())
    }
  }

  //创建右键菜单
  private createMenu() {
    let myMenu1Exist = document.getElementById('myMenu1')
    if (!myMenu1Exist) {
      let myMenu1 = document.createElement('div')
      myMenu1.id = 'myMenu1'
      myMenu1.className = 'contextMenu'
      let ul = document.createElement('ul')
      myMenu1.appendChild(ul)
      let li = document.createElement('li')
      li.id = 'copy'
      li.innerHTML = '复&nbsp;&nbsp;&nbsp;制'
      ul.appendChild(li)
      document.body.appendChild(myMenu1)
      $(document).contextMenu(
        'myMenu1',
        {
          bindings: {
            'copy': () => {
              this.onCopy()
            }
          }
        });
    }
  }
  //删除右键菜单
  public deleteMenu() {
    $('.contextMenu').remove()
    $('#jqContextMenu').hide().next().hide()
  }

  private createFullMenu() {
    let myMenu1Exist = document.getElementById('myFullMenu1')
    if (!myMenu1Exist) {
      let myMenu1 = document.createElement('div')
      myMenu1.id = 'myFullMenu1'
      myMenu1.className = 'contextMenu'
      let ul = document.createElement('ul')
      myMenu1.appendChild(ul)
      let li = document.createElement('li')
      li.id = 'copy'
      li.innerHTML = '复&nbsp;&nbsp;&nbsp;制'
      ul.appendChild(li)
      document.getElementById('wrapper').appendChild(myMenu1)
      $('#wrapper').contextMenu(
        'myFullMenu1',
        {
          bindings: {
            'copy': () => {
              this.onCopy()
            }
          }
        });
    }
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////// 
  /////////////////////////////////pptreader独有的方法////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////// 

  /**
   * @param {*} mode 0:单页模式; 1:连续模式
   */

  public setViewMode() {
    if (this.viewMode) {
      this.viewMode = ViewMode.SinglePage
      $('#viewModel').attr('title', '浏览模式--单页')
      $('#viewModel img').css('border', '0px')
      if (this.showComment) {
        $('#comment').css({
          "display": "block"
        })
      }
    } else {
      this.viewMode = ViewMode.Contious
      $('#viewModel').attr('title', '浏览模式--连续')
      $('#viewModel img').css('border', '1px solid lightgray')
      if (this.showComment) {
        $('#comment').css({
          "display": "none"
        })
      }
    }
    this.resizeWindow(this.currentZoom);
    this.gotoPage(this.startPageIndex); // 解决BUG号 DCC-4349
  }

  /**
   * 设置全屏
   */
  public fullscreenState = false
  public autoAimatePlay = false
  public autoAimatePlayTime = 1000
  private contiousFull = false
  private socketClass
  public socketState: boolean = false
  // public socket: Socket
  public setFullScreen(autoAimatePlay: boolean) {
    // // 如果浏览模式为连续模式，立即跳转至单页模式
    if (this.viewMode === ViewMode.Contious) {
      this.setViewMode()
      this.contiousFull = true
    }
    // let readerWrapper: any = document.getElementById('dcs-pgreader-canvaswrapper')
    let readerWrapper: any = document.getElementById('wrapper')
    // let readerWrapper: any = document.body
    let fullscreenState = this.fullscreenState
    // let requestMethod = readerWrapper.webkitRequestFullScreen || //FireFox
    //     readerWrapper.requestFullScreen || //W3C
    //     readerWrapper.mozRequestFullScreen //Chrome等
    // let cancelMethod = (document as any).mozCancelFullScreen || //FireFox
    //     document.exitFullscreen || //W3C
    //     (document as any).webkitExitFullscreen //Chrome等

    if (!fullscreenState) {
      // 首先删除页面存在的音频和视频
      if ($('video, audio').length > 0) {
        // 设置延迟是为了解决全屏后删除video, audio但是却能遗留下标签的问题
        setTimeout(() => {
          $('video, audio').remove();
        }, 50);
      }
      // 删除Gif图片
      if ($('.canvasGif').length > 0) {
        $('.canvasGif').remove()
      }
      // 删除超链接图片
      if ($('.canvasHyperImage').length > 0) {
        $('.canvasHyperImage').remove()
      }
      // 隐藏左右侧跳转箭头
      $('#leftBtn,#rightBtn').addClass('hiden')
      this.isPaintSelect = false
      // if ((document.body as any).msRequestFullscreen) {
      //     (document.body as any).msRequestFullscreen.call(readerWrapper)
      // } else {
      //     requestMethod.call(readerWrapper)
      // }
      // 每次全屏的时候，左侧缩略图一直隐藏
      this.isHide = true

      this.fullscreenState = true
      let pages = this.doc.pages
      let page: Page
      if (autoAimatePlay) {
        page = pages[0]
        this.startPageIndex = 0 // 从头开始播放
        this.autoAimatePlay = true
        setTimeout(() => {
          AnimationManager.instance.next()
        }, this.autoAimatePlayTime);
      } else {
        page = pages[this.startPageIndex]
      }
      AnimationManager.instance.beginPage(page as Slide)
      // this.isHideSidebar(true)

    } else {
      this.isPaintSelect = true
    }
  }
  // public setFullScreen(autoAimatePlay: boolean) {
  //     // // 如果浏览模式为连续模式，立即跳转至单页模式
  //     if (this.viewMode === ViewMode.Contious) {
  //         this.setViewMode()
  //         this.contiousFull = true
  //     }
  //     // let readerWrapper: any = document.getElementById('dcs-pgreader-canvaswrapper')
  //     let readerWrapper: any = document.getElementById('wrapper')
  //     // let readerWrapper: any = document.body
  //     let fullscreenState = this.fullscreenState
  //     let requestMethod = readerWrapper.webkitRequestFullScreen || //FireFox
  //         readerWrapper.requestFullScreen || //W3C
  //         readerWrapper.mozRequestFullScreen //Chrome等
  //     let cancelMethod = (document as any).mozCancelFullScreen || //FireFox
  //         document.exitFullscreen || //W3C
  //         (document as any).webkitExitFullscreen //Chrome等

  //     if (!fullscreenState) {
  //         // 首先删除页面存在的音频和视频
  //         if ($('video, audio').length > 0) {
  //             // 设置延迟是为了解决全屏后删除video, audio但是却能遗留下标签的问题
  //             setTimeout(() => {
  //                 $('video, audio').remove();
  //             }, 50);
  //         }
  //         // 删除Gif图片
  //         if ($('.canvasGif').length > 0) {
  //             $('.canvasGif').remove()
  //         }
  //         // 删除超链接图片
  //         if ($('.canvasHyperImage').length > 0) {
  //             $('.canvasHyperImage').remove()
  //         }
  //         // 隐藏左右侧跳转箭头
  //         $('#leftBtn,#rightBtn').addClass('hiden')
  //         this.isPaintSelect = false
  //         if ((document.body as any).msRequestFullscreen) {
  //             (document.body as any).msRequestFullscreen.call(readerWrapper)
  //         } else {
  //             requestMethod.call(readerWrapper)
  //         }
  //         // 每次全屏的时候，左侧缩略图一直隐藏
  //         this.isHide = true

  //         this.fullscreenState = true
  //         let pages = this.doc.pages
  //         let page: Page
  //         if (autoAimatePlay) {
  //             page = pages[0]
  //             this.startPageIndex = 0 // 从头开始播放
  //             this.autoAimatePlay = true
  //             setTimeout(() => {
  //                 AnimationManager.instance.next()
  //             }, this.autoAimatePlayTime);
  //         } else {
  //             page = pages[this.startPageIndex]
  //         }
  //         AnimationManager.instance.beginPage(page as Slide)
  //         this.isHideSidebar(true)

  //         // // 链接socket通信
  //         // if (this.isSocket) {
  //         //     this.socketClass = new SolveSocket(this.pageUrlRoot, this.role)
  //         //     this.socketClass.connectSoket()
  //         //     this.socket = this.socketClass.socket
  //         //     this.socketState = true
  //         // }
  //     } else {
  //         this.isPaintSelect = true
  //         if ((document as any).msExitFullscreen) {
  //             (document as any).msExitFullscreen.call(document)
  //         } else {
  //             cancelMethod.call(document)
  //         }
  //     }
  // }

  private fullStateListener() {
    if (!this.checkFull()) {
      this.autoAimatePlay = false
      this.fullscreenState = false
      this.isPaintSelect = true
      this.isHide = false
      // 首先删除页面存在的音频和视频
      if ($('video, audio').length > 0) {
        // 设置延迟是为了解决全屏后删除video, audio但是却能遗留下标签的问题
        $('video, audio').remove();
      }
      // 首先删除页面超链接的图片
      if ($('.canvasHyperImage').length > 0) {
        $('.canvasHyperImage').remove();
      }
      this.isHideSidebar(true);
      $('#leftBtn,#rightBtn').removeClass('hiden')
      // 退出的时候需要去除黑屏
      if (!$('#blackCover').hasClass('hiden')) {
        $('#blackCover').addClass('hiden')
        return
      }
      // 判断是否存在备注
      if ($('#comment').length > 0) {
        $('#comment').css({
          "display": "block"
        })
      }
      // 清除存在的定时器
      clearTimeout(AnimationManager.instance.delayAnimateId)
      this.closeSign()
      $('#signMenu').remove()
      // 如果一开始浏览模式为连续的时候，然后进入播放状态，然后又退出进入到浏览模式为连续
      if (this.contiousFull) {
        this.setViewMode()
        this.contiousFull = false
      }
      // 关闭socket通信

      // if (this.isSocket) {
      //     this.socketClass.disconnectSoket()
      //     this.socketState = false
      // }
    } else {
      // 判断是否存在备注,进入播放状态的时候需要隐藏备注
      if ($('#comment').length > 0) {
        $('#comment').css({
          "display": "none"
        })
      }
    }
  }

  private setAnimation() {
    AnimationManager.instance.next()
  }

  private toolBarTimer
  private showMenu() {
    clearTimeout(this.toolBarTimer)
    let signMenuExist = document.getElementById('signMenu')
    let wrapper = document.getElementById('dcs-pgreader-wrapper')
    let html =
      `<div class="icon" onclick="reader.showIcon(1)">
            <img src="./ppt/ic-biaoji.png" alt="">
            <div class="menu-list type-menu" style="width: 98px;" title="绘制方式">
                <div class="type-item" onclick="reader.setSignType(-1, 0)" title="退出签批">
                    <img src="./ppt/ic-jiantou.png" alt="">
                    箭头
                </div>
                <div class="type-item" onclick="reader.setSignType(0, 2)" title="圆珠笔">
                    <img src="./ppt/ic-yuanzhubi.png" alt="">
                    圆珠笔
                </div>
                <div class="type-item" onclick="reader.setSignType(0, 1)" title="水彩笔">
                    <img src="./ppt/ic-caibi.png" alt="">
                    水彩笔
                </div>
                <div class="type-item" onclick="reader.setSignType(2, 1)" title="绘制线条">
                    <img src="./ppt/ic-quxian.png" alt="">
                    线条
                </div>
                <div class="type-item" onclick="reader.setSignType(3, 1)" title="绘制圆圈">
                    <img src="./ppt/ic-yuan.png" alt="">
                    圆圈
                </div>
                <div class="type-item" onclick="reader.setSignType(4, 1)" title="绘制方框">
                    <img src="./ppt/ic-fangkuang.png" alt="">
                    方框
                </div>
            </div>
        </div>
        <div class="icon" onclick="reader.showIcon(2)" title="笔迹颜色">
            <img src="./ppt/ic-color.png" alt="">
            <div class="menu-list color-menu" >
                <div class="color-item" style="background-color: #ffffff;" onclick="reader.setSignColor(event)"></div>
                <div class="color-item" style="background-color: #000000;" onclick="reader.setSignColor(event)"></div>
                <div class="color-item" style="background-color: #c00100;" onclick="reader.setSignColor(event)"></div>
                <div class="color-item" style="background-color: #ff0100;" onclick="reader.setSignColor(event)"></div>
                <div class="color-item" style="background-color: #febf00;" onclick="reader.setSignColor(event)"></div>
                <div class="color-item" style="background-color: #92cf51;" onclick="reader.setSignColor(event)"></div>
                <div class="color-item" style="background-color: #00af50;" onclick="reader.setSignColor(event)"></div>
                <div class="color-item" style="background-color: #00b0f0;" onclick="reader.setSignColor(event)"></div>
                <div class="color-item" style="background-color: #001f60;" onclick="reader.setSignColor(event)"></div>
                <div class="color-item" style="background-color: #7030a0;" onclick="reader.setSignColor(event)"></div>
            </div>
        </div>
        <div class="icon" onclick="reader.showIcon(3)" title="擦除工具">
            <img src="./ppt/ic-xiangpi_1.png" alt="">
            <div class="menu-list type-menu" style="width: 225px;">
                <div class="type-item" onclick="reader.setSignType(0, 3)">
                    <img src="./ppt/ic-xiangpi.png" alt="">
                    橡皮擦
                </div>
                <div class="type-item" onclick="reader.clearSign()">
                    <img src="./ppt/ic-cachu.png" alt="">
                    擦去当前幻灯片上所有标记
                </div>
            </div>
        </div>
        <div class="icon" onclick="reader.showIcon(4)" title="隐藏签批">
            <img src="./ppt/ic-xianshi.png" alt="">
        </div>`
    if (!signMenuExist) {
      let signMenu = document.createElement('div')
      signMenu.id = 'signMenu'
      signMenu.className = 'icon-list'
      signMenu.innerHTML = html
      wrapper.appendChild(signMenu)
      signMenuExist = signMenu
    } else {
      signMenuExist.style.display = 'block'
    }
    this.toolBarTimer = setTimeout(() => {
      signMenuExist.style.display = 'none'
    }, 3000)
  }

  public showIcon(type: number) {
    this.isSign = true
    clearTimeout(this.toolBarTimer)
    switch (type) {
      case 1:
        let icon1 = $('.icon-list .icon:eq(0)')
        icon1.children('.menu-list').toggle()
        icon1.siblings().children('.menu-list').hide()
        break
      case 2:
        let icon2 = $('.icon-list .icon:eq(1)')
        icon2.children('.menu-list').toggle()
        icon2.siblings().children('.menu-list').hide()
        break
      case 3:
        let icon3 = $('.icon-list .icon:eq(2)')
        icon3.children('.menu-list').toggle()
        icon3.siblings().children('.menu-list').hide()
        break
      case 4:
        if ($('.icon-list .icon:eq(3)').hasClass('active')) {
          $('.icon-list .icon:eq(3)').removeClass('active')
          this.signPad.style.display = 'block'
        } else {
          $('.icon-list .icon:eq(3)').addClass('active')
          this.signPad.style.display = 'none'
        }
        // 如果处于同步发送状态，需要发送数据
        // if (this.socketState && this.role === 1) {
        //     this.socket.emit('pptshowSignatureIcon', true);
        // }
        break
    }
    this.toolBarTimer = setTimeout(() => {
      document.getElementById('signMenu').style.display = 'none'
    }, 3000)
  }

  public showGetShowSignatureIcon() {
    this.isSign = true
    clearTimeout(this.toolBarTimer)
    if ($('.icon-list .icon:eq(3)').hasClass('active')) {
      $('.icon-list .icon:eq(3)').removeClass('active')
      this.signPad.style.display = 'block'
    } else {
      $('.icon-list .icon:eq(3)').addClass('active')
      this.signPad.style.display = 'none'
    }
    this.toolBarTimer = setTimeout(() => {
      document.getElementById('signMenu').style.display = 'none'
    }, 3000)
  }

  public setSignType(type: number, sharp: number) {
    if (type !== -1) {
      this.isSign = true
      this.signPad.style.pointerEvents = 'auto'
      this.canvas.style.pointerEvents = 'none'
      if (!this.signaturePad) {
        this.signaturePad = new (window as any).SignaturePad(this.signPad, {
          maxWidth: 3,
          minWidth: 1.5,
          penColor: 'black',
          onEnd: (pad) => {
            // 如果处于同步发送状态，需要发送数据
            // if (this.socketState && this.role === 1) {
            //     this.socket.emit('pptSignature', pad._drawStatus[pad.level]);
            // }
          }
        })
      }
      this.signaturePad.drawType = type
      this.signaturePad.sharpType = sharp
    } else {
      this.closeSign()
    }
  }

  public gotoSignature(msg: []) {
    if (!msg || msg.length === 0) return
    if (!this.signaturePad) {
      this.signaturePad = new (window as any).SignaturePad(this.signPad, {
        maxWidth: 3,
        minWidth: 1.5,
        penColor: 'black'
      })
    }
    this.signaturePad.addPaint(msg[msg.length - 1])
  }

  public setSignColor(event) {
    this.isSign = true
    this.signPad.style.pointerEvents = 'auto'
    this.canvas.style.pointerEvents = 'none'
    if (!this.signaturePad) {
      this.signaturePad = new (window as any).SignaturePad(this.signPad, {
        sharpType: 1,
        maxWidth: 3,
        minWidth: 1.5
      })
    }
    let color = event.target.style.backgroundColor
    this.signaturePad.penColor = color
  }

  private closeSign() {
    this.signPad.style.pointerEvents = 'none'
    this.canvas.style.pointerEvents = 'auto'
    if (this.signaturePad) this.signaturePad.clear()
    setTimeout(() => {
      this.isSign = false
    }, 100)
  }

  public clearSign() {
    // 如果处于同步发送状态，需要发送数据
    // if (this.socketState && this.role === 1) {
    //     this.socket.emit('pptClearSign', false);
    // }
    if (!this.signaturePad) return
    this.signaturePad.clear()
  }

  // public clearSocketSign() {
  //     if (!this.signaturePad) return
  //     this.signaturePad.clear()
  // }

  private checkFull() {
    return document.fullscreenElement ||
      (document as any).msFullscreenElement ||
      (document as any).mozFullScreenElement ||
      (document as any).webkitFullscreenElement || false;
  }

  private solveRectAimate(rect) {
    let shape = Object.create(null);
    shape.textRect = Object.create(null)
    shape.textRect.x = rect[0];
    shape.textRect.y = rect[1];
    shape.textRect.width = rect[2];
    shape.textRect.height = rect[3];
    shape.shapeRect = Object.create(null)
    shape.shapeRect.x = rect[0];
    shape.shapeRect.y = rect[1];
    shape.shapeRect.width = rect[2];
    shape.shapeRect.height = rect[3];
    return shape;
  }

  private solveTextInfo(shape) {
    if (!shape) return;
    let textInfo = [];
    let textInfoMap = shape.textRect;
    textInfo[0] = textInfoMap.x;
    textInfo[1] = textInfoMap.y;
    textInfo[2] = textInfoMap.width;
    textInfo[3] = textInfoMap.height;
    return textInfo;
  }

  private solveAimate(groupData) {
    let shape
    if (groupData.length === 1) {
      shape = this.solveAimateEach(groupData[0])
    } else {
      let shapeArray = []
      for (let obj of groupData) {
        shapeArray.push(this.solveAimateEach(obj))
      }
      // 开始将这些点的坐标计算成一个总的rect区域
      shape = this.calAllFlyerRect(shapeArray)
    }


    if (!shape) return
    if (shape.shapeRect && !shape.textRect) {
      shape.textRect = Object.create(null)
      shape.textRect.x = shape.shapeRect.x
      shape.textRect.y = shape.shapeRect.y
      shape.textRect.width = shape.shapeRect.width
      shape.textRect.height = shape.shapeRect.height
    } else if (!shape.shapeRect && shape.textRect) {
      shape.shapeRect = Object.create(null)
      shape.shapeRect.x = shape.textRect.x
      shape.shapeRect.y = shape.textRect.y
      shape.shapeRect.width = shape.textRect.width
      shape.shapeRect.height = shape.textRect.height
    }
    return shape
  }


  // 开始将这些点的坐标计算成一个总的rect区域
  private calAllFlyerRect(shapeArray) {
    let rect1 = this.textOrShape(shapeArray[0])
    for (let i = 1; i < shapeArray.length; i++) {
      let rect2 = this.textOrShape(shapeArray[i])
      if (rect2.x1 < rect1.x1) rect1.x1 = rect2.x1
      if (rect2.y1 < rect1.y1) rect1.y1 = rect2.y1
      if (rect2.x2 > rect1.x2) rect1.x2 = rect2.x2
      if (rect2.y2 > rect1.y2) rect1.y2 = rect2.y2
    }
    let shape = Object.create(null)
    shape.shapeRect = Object.create(null)
    shape.shapeRect.x = rect1.x1
    shape.shapeRect.y = rect1.y1
    shape.shapeRect.width = rect1.x2 - rect1.x1
    shape.shapeRect.height = rect1.y2 - rect1.y1
    return shape
  }

  private textOrShape(shape) {
    let rect = Object.create(null)
    if (shape.shapeRect && !shape.textRect) {
      rect.x1 = shape.shapeRect.x
      rect.y1 = shape.shapeRect.y
      rect.x2 = shape.shapeRect.width + shape.shapeRect.x
      rect.y2 = shape.shapeRect.height + shape.shapeRect.y
    } else if (!shape.shapeRect && shape.textRect) {
      rect.x1 = shape.textRect.x
      rect.y1 = shape.textRect.y
      rect.x2 = shape.textRect.width + shape.textRect.x
      rect.y2 = shape.textRect.height + shape.textRect.y
    }
    return rect
  }

  private solveAimateEach(groupData) {
    let shape
    switch (groupData.t) {
      case ObjType.Text:
        shape = this.calAnimateTextInfo(groupData)
        break
      case ObjType.Image:
        shape = this.calAnimateImageInfo(groupData)
        break
      case ObjType.Path:
        shape = this.calAnimatePathInfo(groupData)
        break
    }
    return shape
  }

  private calAnimatePathInfo(groupData) {
    let shape = Object.create(null)
    shape.shapeRect = Object.create(null)
    shape.shapeRect.x = groupData.rect[0]
    shape.shapeRect.y = groupData.rect[1]
    shape.shapeRect.width = groupData.rect[2]
    shape.shapeRect.height = groupData.rect[3]
    return shape
  }

  private calAnimateImageInfo(groupData) {
    let shape = Object.create(null)
    shape.shapeRect = Object.create(null)
    shape.shapeRect.x = groupData.rect[0]
    shape.shapeRect.y = groupData.rect[1]
    shape.shapeRect.width = groupData.rect[2]
    shape.shapeRect.height = groupData.rect[3]
    return shape
  }

  private calAnimateTextInfo(obj) {
    let linemap = Object.create(null), charx: number[], line: Line, v: string, char: Char
    charx = (obj as TextObj).charx
    line = linemap[(obj as TextObj).y]
    if (!line) {
      line = Object.create(null)
      line.y = (obj as TextObj).y
      line.height = (obj as TextObj).h
      line.chars = []
      linemap[(obj as TextObj).y] = line
    } else {//同一行字符，height取高度最高的
      if (line.height < (obj as TextObj).h) {
        line.height = (obj as TextObj).h
      }
    }
    let charX = (obj as TextObj).charX
    let charIndex = 1;
    let startX = (obj as TextObj).startX
    v = (obj as TextObj).v as string
    char = Object.create(null)
    char.t = v[0]
    char.x = startX
    char.width = this.lastCharWidth((obj as TextObj).h)
    line.chars.push(char)
    if (charX) {
      for (let i = 0; i < charX.length; i++) {
        if (i == charX.length - 1) {
          if (typeof charX[i] === "number") {
            char = Object.create(null)
            char.t = v[charIndex]
            char.x = charX[i] as number
            char.width = this.lastCharWidth((obj as TextObj).h)
            line.chars.push(char)
          }
        }
        else {
          if (typeof charX[i + 1] === "number") {
            char = Object.create(null)
            startX = <number>charX[i]
            char.t = v[charIndex]
            char.x = startX
            char.width = <number>charX[i + 1] - <number>charX[i]
            line.chars.push(char)
            charIndex++
          }
          else {
            let num: number = parseInt((<string>charX[i + 1]).replace("g", ""))
            for (let j = 1; j < num + 1; j++) {
              char = Object.create(null)
              startX += <number>charX[i]
              char.t = v[charIndex]
              char.x = startX
              char.width = <number>charX[i]
              line.chars.push(char)
              charIndex++
            }
            i++
          }
        }
      }
    }

    let lines = []
    for (let y in linemap) {
      //起始字符位置
      linemap[y].x = linemap[y]['chars'][0].x
      //因为上面的逻辑取宽度是错误的，所以需要重新计算宽度,最后一宽度已经在上面计算过了，所以不用重新计算了
      let pre: Char
      for (let i = 0; i < linemap[y]['chars'].length; i++) {
        if (pre) pre.width = linemap[y]['chars'][i].x - pre.x
        pre = linemap[y]['chars'][i]
      }
      //整个line的宽度
      linemap[y].width = linemap[y]['chars'][linemap[y]['chars'].length - 1].x - linemap[y]['chars'][0].x + linemap[y]['chars'][linemap[y]['chars'].length - 1].width
      lines.push(linemap[y])
    }
    lines.sort(this.yComparator)
    for (let info of lines) {
      info.y = info.y - info.height + this.calTextHeightOffset(info.height)
    }
    let shape = Object.create(null)
    shape.textRect = Object.create(null)
    shape.textRect.x = lines[0].x
    shape.textRect.y = lines[0].y
    shape.textRect.width = lines[0].width
    shape.textRect.height = lines[0].height
    return shape
  }

  private paraIdMin: number = 0
  private paraDataSolve(groupData) {
    let paraDataListMap = {}
    for (let info of groupData) {
      if (info.meta) {
        if (!paraDataListMap[info.meta[2]]) {
          paraDataListMap[info.meta[2]] = []
          paraDataListMap[info.meta[2]].push(info)
        } else {
          paraDataListMap[info.meta[2]].push(info)
        }
      }
    }
    let numList = []
    for (let num in paraDataListMap) {
      numList.push(num)
    }
    numList.sort((a, b) => {
      return a - b
    })
    let minNum = this.paraIdMin = Number(numList[0]);
    let paraDataList = []
    // praid 不是连续的的，可能中间有空白部分（DCC-6260）
    for (let i = 0; i < numList.length; i++) {
      paraDataList[Number(numList[i]) - minNum] = paraDataListMap[numList[i]];
    }
    return paraDataList
  }

  public setParentSize(width, height) {
    this.parentWidth = width
    this.parentHeight = height
  }

  // 39互联网上一页，下一页
  public goNext() {
    AnimationManager.instance.next();
  }
  // 39互联网上一页，上一页
  public goPrev() {
    AnimationManager.instance.pre();
  }
}